export const rent = [
	{
		"id": 9003,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Metsäsaimaankatu 17",
		"postalCode": "53950",
		"city": "Lappeenranta",
		"livingArea": 36.0,
		"yearOfConstruction": null,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 415.0,
		"rentCalcSqm": 11.5278,
		"owner": "Asuntomesta Oy LKV",
		"source": "vuokraovi",
		"condition": "välttävä",
		"hasSauna": false,
		"observationTime": "2021-09-07T21:30:19Z",
		"x": 28.1505,
		"y": 61.0915
	},
	{
		"id": 15252,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Liusketie 2",
		"postalCode": "00710",
		"city": "Helsinki",
		"livingArea": 24.5,
		"yearOfConstruction": 1963,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 490.0,
		"rentCalcSqm": 20.0,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "välttävä",
		"hasSauna": false,
		"observationTime": "2021-10-05T21:30:35Z",
		"x": 25.0132,
		"y": 60.2356
	},
	{
		"id": 17884,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Cygnaeuksenkatu 5",
		"postalCode": "40100",
		"city": "Jyväskylä",
		"livingArea": 22.5,
		"yearOfConstruction": 1959,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 400.0,
		"rentCalcSqm": 17.7778,
		"owner": "Kiinteistömaailma Jyväskylä Tourula | PR-Neliöt Oy",
		"source": "vuokraovi",
		"condition": "välttävä",
		"hasSauna": false,
		"observationTime": "2021-10-19T21:30:09Z",
		"x": 25.7407,
		"y": 62.2389
	},
	{
		"id": 19520,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Leikosaarentie 12",
		"postalCode": "00980",
		"city": "Helsinki",
		"livingArea": 45.0,
		"yearOfConstruction": 1995,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 827.0,
		"rentCalcSqm": 18.3778,
		"owner": "SATO Vuokraus / Helsinki",
		"source": "vuokraovi",
		"condition": "välttävä",
		"hasSauna": true,
		"observationTime": "2021-10-26T21:30:11Z",
		"x": 25.1375,
		"y": 60.2028
	},
	{
		"id": 89579,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Mertakaari 30",
		"postalCode": "70800",
		"city": "Kuopio",
		"livingArea": 40.0,
		"yearOfConstruction": 1991,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 475.0,
		"rentCalcSqm": 11.875,
		"owner": "Olo Asunnot 11 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6393,
		"y": 62.8294
	},
	{
		"id": 87967,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Schwerininkatu 6",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 64.0,
		"yearOfConstruction": 1971,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 666.6,
		"rentCalcSqm": 10.4156,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6579,
		"y": 63.0765
	},
	{
		"id": 84803,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suokatu 29",
		"postalCode": "70110",
		"city": "Kuopio",
		"livingArea": 44.0,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 779.0,
		"rentCalcSqm": 17.7045,
		"owner": "OP-Vuokratuotto -erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6786,
		"y": 62.8951
	},
	{
		"id": 84977,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pohjoinen Rautatiekatu 30",
		"postalCode": "00100",
		"city": "Helsinki",
		"livingArea": 42.0,
		"yearOfConstruction": 2016,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 1104.0,
		"rentCalcSqm": 26.2857,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 24.9228,
		"y": 60.1678
	},
	{
		"id": 89677,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Rypysuontie 63",
		"postalCode": "70280",
		"city": "Kuopio",
		"livingArea": 58.5,
		"yearOfConstruction": 1976,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 590.0,
		"rentCalcSqm": 10.0855,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6329,
		"y": 62.9176
	},
	{
		"id": 86843,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Tieteenkatu 9",
		"postalCode": "33720",
		"city": "Tampere",
		"livingArea": 30.0,
		"yearOfConstruction": 2020,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 614.0,
		"rentCalcSqm": 20.4667,
		"owner": "OP-Vuokratuotto -erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 23.8499,
		"y": 61.4566
	},
	{
		"id": 88237,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Porokatu 37",
		"postalCode": "96400",
		"city": "Rovaniemi",
		"livingArea": 43.0,
		"yearOfConstruction": 1966,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 575.0,
		"rentCalcSqm": 13.3721,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7718,
		"y": 66.494
	},
	{
		"id": 86991,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hellberginpolku 1",
		"postalCode": "06100",
		"city": "Porvoo",
		"livingArea": 59.0,
		"yearOfConstruction": 2021,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 1020.0,
		"rentCalcSqm": 17.2881,
		"owner": "OP-Vuokratuotto -erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6537,
		"y": 60.3863
	},
	{
		"id": 87114,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Peltolantie 38",
		"postalCode": "01300",
		"city": "Vantaa",
		"livingArea": 62.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 1063.0,
		"rentCalcSqm": 17.008,
		"owner": "OP-Vuokratuotto -erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.008,
		"y": 60.294
	},
	{
		"id": 89483,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kielorannankatu 8",
		"postalCode": "70820",
		"city": "Kuopio",
		"livingArea": 28.5,
		"yearOfConstruction": 1991,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 425.0,
		"rentCalcSqm": 14.9123,
		"owner": "Olo Asunnot 11 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6547,
		"y": 62.8336
	},
	{
		"id": 89968,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kotisaarenkatu 3",
		"postalCode": "00560",
		"city": "Helsinki",
		"livingArea": 65.0,
		"yearOfConstruction": 2009,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 1369.0,
		"rentCalcSqm": 21.0615,
		"owner": "OP-Vuokratuotto -erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 24.9696,
		"y": 60.2024
	},
	{
		"id": 101759,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Päiviönkatu 26",
		"postalCode": "74100",
		"city": "Iisalmi",
		"livingArea": 63.0,
		"yearOfConstruction": 1950,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 620.0,
		"rentCalcSqm": 9.8413,
		"owner": "Olo Asunnot 4 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.1923,
		"y": 63.5609
	},
	{
		"id": 93562,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kivikatu 9",
		"postalCode": "15700",
		"city": "Lahti",
		"livingArea": 68.0,
		"yearOfConstruction": 2008,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 921.0,
		"rentCalcSqm": 13.5441,
		"owner": "OP-Vuokratuotto -erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.637,
		"y": 60.9676
	},
	{
		"id": 94695,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Limingantie 2",
		"postalCode": "90400",
		"city": "Oulu",
		"livingArea": 40.0,
		"yearOfConstruction": 2018,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 705.0,
		"rentCalcSqm": 17.625,
		"owner": "OP-Vuokratuotto -erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4625,
		"y": 65.0024
	},
	{
		"id": 99291,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Norkkokuja 1",
		"postalCode": "01360",
		"city": "Vantaa",
		"livingArea": 30.5,
		"yearOfConstruction": 2021,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 730.0,
		"rentCalcSqm": 23.9344,
		"owner": "Oivat Kaupunkikodit Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.0545,
		"y": 60.3232
	},
	{
		"id": 99172,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Norkkokuja 1",
		"postalCode": "01360",
		"city": "Vantaa",
		"livingArea": 31.5,
		"yearOfConstruction": 2021,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 740.0,
		"rentCalcSqm": 23.4921,
		"owner": "Oivat Kaupunkikodit Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.0545,
		"y": 60.3232
	},
	{
		"id": 100214,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Nelikkokuja 5",
		"postalCode": "02230",
		"city": "Espoo",
		"livingArea": 38.5,
		"yearOfConstruction": 2004,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 909.0,
		"rentCalcSqm": 23.6104,
		"owner": "Keskinäinen Työeläkevakuutusyhtiö Elo",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 24.7407,
		"y": 60.1611
	},
	{
		"id": 100401,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Norkkokuja 1",
		"postalCode": "01360",
		"city": "Vantaa",
		"livingArea": 30.5,
		"yearOfConstruction": 2021,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 735.0,
		"rentCalcSqm": 24.0984,
		"owner": "Oivat Kaupunkikodit Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.0545,
		"y": 60.3232
	},
	{
		"id": 103512,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Paturintie 19",
		"postalCode": "28610",
		"city": "Pori",
		"livingArea": 30.0,
		"yearOfConstruction": 1974,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 399.0,
		"rentCalcSqm": 13.3,
		"owner": "Olo Asunnot 4 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.7371,
		"y": 61.4841
	},
	{
		"id": 103513,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Paturintie 17",
		"postalCode": "28610",
		"city": "Pori",
		"livingArea": 73.0,
		"yearOfConstruction": 1974,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 589.0,
		"rentCalcSqm": 8.0685,
		"owner": "Olo Asunnot 4 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.7357,
		"y": 61.4841
	},
	{
		"id": 105027,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Sepänkatu 2",
		"postalCode": "26100",
		"city": "Rauma",
		"livingArea": 55.0,
		"yearOfConstruction": 1968,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 575.0,
		"rentCalcSqm": 10.4545,
		"owner": "Olo Asunnot 3 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.5049,
		"y": 61.1172
	},
	{
		"id": 107381,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Adjutantinkatu 3",
		"postalCode": "02650",
		"city": "Espoo",
		"livingArea": 34.0,
		"yearOfConstruction": 2012,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 850.0,
		"rentCalcSqm": 25.0,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 24.8344,
		"y": 60.2217
	},
	{
		"id": 109803,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Lintulahdenkatu 6",
		"postalCode": "00500",
		"city": "Helsinki",
		"livingArea": 32.0,
		"yearOfConstruction": 2011,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 840.0,
		"rentCalcSqm": 26.25,
		"owner": "Nordea Henkivakuutus Suomi Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 24.9616,
		"y": 60.1842
	},
	{
		"id": 112153,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Rälssitilankuja 4",
		"postalCode": "02200",
		"city": "Espoo",
		"livingArea": 39.5,
		"yearOfConstruction": null,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 910.0,
		"rentCalcSqm": 23.038,
		"owner": "Juli Niittykummun Vaahtera Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 24.7602,
		"y": 60.1715
	},
	{
		"id": 112202,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Loiskekuja 6",
		"postalCode": "01600",
		"city": "Vantaa",
		"livingArea": 44.5,
		"yearOfConstruction": 2017,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 884.0,
		"rentCalcSqm": 19.8652,
		"owner": "IC Kodit RPF II",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 24.843,
		"y": 60.2725
	},
	{
		"id": 112429,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Jauhajankuja 2",
		"postalCode": "00990",
		"city": "Helsinki",
		"livingArea": 40.5,
		"yearOfConstruction": 2012,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 904.0,
		"rentCalcSqm": 22.321,
		"owner": "Asunto Lily Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.1499,
		"y": 60.205
	},
	{
		"id": 113320,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kiviaidankatu 7",
		"postalCode": "00210",
		"city": "Helsinki",
		"livingArea": 43.0,
		"yearOfConstruction": 2017,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 1134.0,
		"rentCalcSqm": 26.3721,
		"owner": "Rosa Housing Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 24.8824,
		"y": 60.1545
	},
	{
		"id": 114939,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Rauhankatu 2",
		"postalCode": "15110",
		"city": "Lahti",
		"livingArea": 237.5,
		"yearOfConstruction": 1945,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 3750.0,
		"rentCalcSqm": 15.7895,
		"owner": "A1 AH 2 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6524,
		"y": 60.9809
	},
	{
		"id": 116863,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Mallastie 16",
		"postalCode": "90520",
		"city": "Oulu",
		"livingArea": 53.0,
		"yearOfConstruction": 2017,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 8,
		"rentCalc": 783.0,
		"rentCalcSqm": 14.7736,
		"owner": "S-Pankki Asunto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4474,
		"y": 65.032
	},
	{
		"id": 119303,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kuvastimentie 1",
		"postalCode": "02210",
		"city": "Espoo",
		"livingArea": 48.0,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 905.0,
		"rentCalcSqm": 18.8542,
		"owner": "Centaurus Finland Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 24.7171,
		"y": 60.1783
	},
	{
		"id": 7078,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 35.5,
		"yearOfConstruction": 2015,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 843.0,
		"rentCalcSqm": 23.7465,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 7079,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 36.5,
		"yearOfConstruction": 2015,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 801.0,
		"rentCalcSqm": 21.9452,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 874,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Itäinen Rantakatu 66",
		"postalCode": "20810",
		"city": "Turku",
		"livingArea": 75.0,
		"yearOfConstruction": 2000,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 1300.0,
		"rentCalcSqm": 17.3333,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": true,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 22.2458,
		"y": 60.4392
	},
	{
		"id": 993,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Koivuharjunkatu 40",
		"postalCode": "94100",
		"city": "Kemi",
		"livingArea": 50.0,
		"yearOfConstruction": 1989,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 550.0,
		"rentCalcSqm": 11.0,
		"owner": "OP Koti Kemi Oy LKV",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": true,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 24.5622,
		"y": 65.7477
	},
	{
		"id": 1026,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Fleminginkatu 8",
		"postalCode": "00530",
		"city": "Helsinki",
		"livingArea": 30.5,
		"yearOfConstruction": 1913,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 830.0,
		"rentCalcSqm": 27.2131,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 24.9526,
		"y": 60.1853
	},
	{
		"id": 1408,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Satamasaarentie 5",
		"postalCode": "9",
		"city": "Helsinki",
		"livingArea": 66.0,
		"yearOfConstruction": 2019,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 1178.0,
		"rentCalcSqm": 17.8485,
		"owner": "Erikoissijoitusrahasto UB Suomi Kiinteistöt",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-07-31T00:00:00Z",
		"x": 25.1386,
		"y": 60.2126
	},
	{
		"id": 7080,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 35.5,
		"yearOfConstruction": 2015,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 843.0,
		"rentCalcSqm": 23.7465,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 1289,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Rusthollinkatu 4",
		"postalCode": "20880",
		"city": "Turku",
		"livingArea": 59.0,
		"yearOfConstruction": 1969,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 640.0,
		"rentCalcSqm": 10.8475,
		"owner": "Etelä-Suomen Kiinteistönvälittäjät LKV Oy",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 22.2637,
		"y": 60.417
	},
	{
		"id": 7081,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 35.5,
		"yearOfConstruction": 2015,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 843.0,
		"rentCalcSqm": 23.7465,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 7082,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 43.0,
		"yearOfConstruction": 2015,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 895.0,
		"rentCalcSqm": 20.814,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 7083,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 35.5,
		"yearOfConstruction": 2015,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 780.0,
		"rentCalcSqm": 21.9718,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 84838,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pitkäkatu 32",
		"postalCode": "65100",
		"city": "Vaasa",
		"livingArea": 40.0,
		"yearOfConstruction": 1998,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 627.0,
		"rentCalcSqm": 15.675,
		"owner": "OP Rent II Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6175,
		"y": 63.0975
	},
	{
		"id": 7084,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 36.5,
		"yearOfConstruction": 2015,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 801.0,
		"rentCalcSqm": 21.9452,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 10,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Lähteenmäentie 18",
		"postalCode": "20660",
		"city": "Kaarina",
		"livingArea": 60.0,
		"yearOfConstruction": 1996,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 450.0,
		"rentCalcSqm": 7.5,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 22.3736,
		"y": 60.4341
	},
	{
		"id": 7085,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 35.0,
		"yearOfConstruction": 2015,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 822.0,
		"rentCalcSqm": 23.4857,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 7086,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Meesakatu 5",
		"postalCode": "330",
		"city": "Tampere",
		"livingArea": 95.0,
		"yearOfConstruction": 2019,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 595.0,
		"rentCalcSqm": 6.2632,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 23.6811,
		"y": 61.5219
	},
	{
		"id": 85056,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Perintötie 4",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 56.5,
		"yearOfConstruction": 2022,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 925.0,
		"rentCalcSqm": 16.3717,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 24.9681,
		"y": 60.2963
	},
	{
		"id": 7087,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Meesakatu 5",
		"postalCode": "330",
		"city": "Tampere",
		"livingArea": 44.0,
		"yearOfConstruction": 2019,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 595.0,
		"rentCalcSqm": 13.5227,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 23.6811,
		"y": 61.5219
	},
	{
		"id": 7088,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Laurinkuja 6",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 51.5,
		"yearOfConstruction": 2021,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 785.0,
		"rentCalcSqm": 15.2427,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4213,
		"y": 60.9823
	},
	{
		"id": 7089,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Laurinkuja 6",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 33.0,
		"yearOfConstruction": 2021,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 785.0,
		"rentCalcSqm": 23.7879,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4213,
		"y": 60.9823
	},
	{
		"id": 88233,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Porokatu 37",
		"postalCode": "96400",
		"city": "Rovaniemi",
		"livingArea": 60.0,
		"yearOfConstruction": 1966,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 685.0,
		"rentCalcSqm": 11.4167,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7718,
		"y": 66.494
	},
	{
		"id": 84997,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Voimakatu 16",
		"postalCode": "33100",
		"city": "Tampere",
		"livingArea": 51.0,
		"yearOfConstruction": 2011,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 900.0,
		"rentCalcSqm": 17.6471,
		"owner": "OP-Eläkesäätiö",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 23.7692,
		"y": 61.4909
	},
	{
		"id": 7090,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Laurinkuja 6",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 48.0,
		"yearOfConstruction": 2021,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 785.0,
		"rentCalcSqm": 16.3542,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4213,
		"y": 60.9823
	},
	{
		"id": 7091,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Laurinkuja 6",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 74.0,
		"yearOfConstruction": 2021,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 785.0,
		"rentCalcSqm": 10.6081,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4213,
		"y": 60.9823
	},
	{
		"id": 7092,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Meesakatu 5",
		"postalCode": "330",
		"city": "Tampere",
		"livingArea": 30.5,
		"yearOfConstruction": 2019,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 595.0,
		"rentCalcSqm": 19.5082,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 23.6811,
		"y": 61.5219
	},
	{
		"id": 7093,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Meesakatu 5",
		"postalCode": "330",
		"city": "Tampere",
		"livingArea": 29.5,
		"yearOfConstruction": 2019,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 595.0,
		"rentCalcSqm": 20.1695,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 23.6811,
		"y": 61.5219
	},
	{
		"id": 1435,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Isokatu 87",
		"postalCode": "1",
		"city": "Oulu",
		"livingArea": 37.0,
		"yearOfConstruction": 2019,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 605.0,
		"rentCalcSqm": 16.3514,
		"owner": "Erikoissijoitusrahasto UB Suomi Kiinteistöt",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-07-31T00:00:00Z",
		"x": 25.4629,
		"y": 65.0037
	},
	{
		"id": 103515,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Paturintie 17",
		"postalCode": "28610",
		"city": "Pori",
		"livingArea": 73.0,
		"yearOfConstruction": 1974,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 589.0,
		"rentCalcSqm": 8.0685,
		"owner": "Olo Asunnot 4 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.7357,
		"y": 61.4841
	},
	{
		"id": 7094,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 35.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 605.0,
		"rentCalcSqm": 17.0423,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7095,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 25.0,
		"yearOfConstruction": 2020,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 500.0,
		"rentCalcSqm": 20.0,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 87659,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Sarvikatu 2",
		"postalCode": "15950",
		"city": "Lahti",
		"livingArea": 50.0,
		"yearOfConstruction": 1982,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 615.0,
		"rentCalcSqm": 12.3,
		"owner": "Olo Asunnot 12 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.5908,
		"y": 60.9944
	},
	{
		"id": 7096,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 46.0,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 655.0,
		"rentCalcSqm": 14.2391,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7097,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 685.0,
		"rentCalcSqm": 14.4211,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7098,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 685.0,
		"rentCalcSqm": 14.4211,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 107850,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Sammonkatu 3",
		"postalCode": "90570",
		"city": "Oulu",
		"livingArea": 75.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 748.0,
		"rentCalcSqm": 9.9073,
		"owner": "Riihi säätiö sr",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.48,
		"y": 65.0589
	},
	{
		"id": 7099,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 695.0,
		"rentCalcSqm": 14.6316,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7100,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 695.0,
		"rentCalcSqm": 14.6316,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 12,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Harjunsalontie 2",
		"postalCode": "36220",
		"city": "Kangasala",
		"livingArea": 32.0,
		"yearOfConstruction": null,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 520.0,
		"rentCalcSqm": 16.25,
		"owner": "FinCap Vuokrauspalvelu Oy, Tampere",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 24.0233,
		"y": 61.4718
	},
	{
		"id": 7101,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Meesakatu 5",
		"postalCode": "330",
		"city": "Tampere",
		"livingArea": 18.0,
		"yearOfConstruction": 2019,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 595.0,
		"rentCalcSqm": 33.0556,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 23.6811,
		"y": 61.5219
	},
	{
		"id": 7102,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Meesakatu 5",
		"postalCode": "330",
		"city": "Tampere",
		"livingArea": 17.0,
		"yearOfConstruction": 2019,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 595.0,
		"rentCalcSqm": 35.0,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 23.6811,
		"y": 61.5219
	},
	{
		"id": 7103,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Meesakatu 5",
		"postalCode": "330",
		"city": "Tampere",
		"livingArea": 45.5,
		"yearOfConstruction": 2019,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 595.0,
		"rentCalcSqm": 13.0769,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 23.6811,
		"y": 61.5219
	},
	{
		"id": 13,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Raatimiehenkatu 4",
		"postalCode": "06100",
		"city": "Porvoo",
		"livingArea": 34.0,
		"yearOfConstruction": 1969,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 630.0,
		"rentCalcSqm": 18.5294,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 25.6508,
		"y": 60.3913
	},
	{
		"id": 7104,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 35.0,
		"yearOfConstruction": 2015,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 822.0,
		"rentCalcSqm": 23.4857,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 7105,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 15.0,
		"yearOfConstruction": 2020,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 680.0,
		"rentCalcSqm": 45.3333,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 90200,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Tikkurilantie 99",
		"postalCode": "01300",
		"city": "Vantaa",
		"livingArea": 97.0,
		"yearOfConstruction": 2015,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 1515.0,
		"rentCalcSqm": 15.6186,
		"owner": "Rosa Housing Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.0079,
		"y": 60.2925
	},
	{
		"id": 90255,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Nihtitorpankuja 5",
		"postalCode": "02630",
		"city": "Espoo",
		"livingArea": 57.0,
		"yearOfConstruction": 2015,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 7,
		"rentCalc": 1042.0,
		"rentCalcSqm": 18.2807,
		"owner": "Rosa Housing Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 24.7564,
		"y": 60.2082
	},
	{
		"id": 109763,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Reelinkikuja 3",
		"postalCode": "02330",
		"city": "Espoo",
		"livingArea": 46.0,
		"yearOfConstruction": 2016,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 884.0,
		"rentCalcSqm": 19.2174,
		"owner": "IC Kodit RPF II",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 24.6177,
		"y": 60.1671
	},
	{
		"id": 7106,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 26.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 680.0,
		"rentCalcSqm": 25.6604,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 14,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Gummeruksenkatu 5",
		"postalCode": "40100",
		"city": "Jyväskylä",
		"livingArea": 24.0,
		"yearOfConstruction": 1959,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 7,
		"rentCalc": 450.0,
		"rentCalcSqm": 18.75,
		"owner": "Jyväskylän Kiinteistöpalvelu Oy",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 25.7444,
		"y": 62.2394
	},
	{
		"id": 90981,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Tanhukaari 6",
		"postalCode": "40520",
		"city": "Jyväskylä",
		"livingArea": 81.0,
		"yearOfConstruction": 2007,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 1005.0,
		"rentCalcSqm": 12.4074,
		"owner": "IC Kodit RPF II",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7523,
		"y": 62.227
	},
	{
		"id": 91562,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Lotankatu 5",
		"postalCode": "02680",
		"city": "Espoo",
		"livingArea": 37.5,
		"yearOfConstruction": 2016,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 795.0,
		"rentCalcSqm": 21.2,
		"owner": "Rosa Housing Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 24.8296,
		"y": 60.2369
	},
	{
		"id": 7107,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 31.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 680.0,
		"rentCalcSqm": 21.5873,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7108,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 74.0,
		"yearOfConstruction": 2020,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 680.0,
		"rentCalcSqm": 9.1892,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 92382,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kotikonnuntie 8",
		"postalCode": "00940",
		"city": "Helsinki",
		"livingArea": 86.0,
		"yearOfConstruction": 2015,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 1369.0,
		"rentCalcSqm": 15.9186,
		"owner": "Rosa Housing Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.0854,
		"y": 60.2407
	},
	{
		"id": 7109,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 37.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 680.0,
		"rentCalcSqm": 18.1333,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7110,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 26.0,
		"yearOfConstruction": 2020,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 680.0,
		"rentCalcSqm": 26.1538,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7111,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 45.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 680.0,
		"rentCalcSqm": 14.9451,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7112,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Melkonkatu 22",
		"postalCode": "2",
		"city": "Helsinki",
		"livingArea": 103.5,
		"yearOfConstruction": 2019,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 1610.0,
		"rentCalcSqm": 15.5556,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8811,
		"y": 60.1522
	},
	{
		"id": 113272,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Meesakatu 3",
		"postalCode": "33400",
		"city": "Tampere",
		"livingArea": 45.5,
		"yearOfConstruction": 2017,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 773.0,
		"rentCalcSqm": 16.989,
		"owner": "IC Kodit RPF II",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 23.6819,
		"y": 61.522
	},
	{
		"id": 93545,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kivikatu 9",
		"postalCode": "15700",
		"city": "Lahti",
		"livingArea": 68.0,
		"yearOfConstruction": 2008,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 900.0,
		"rentCalcSqm": 13.2353,
		"owner": "OP-Vuokratuotto -erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.637,
		"y": 60.9676
	},
	{
		"id": 7113,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 695.0,
		"rentCalcSqm": 14.6316,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7114,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Melkonkatu 22",
		"postalCode": "2",
		"city": "Helsinki",
		"livingArea": 68.5,
		"yearOfConstruction": 2019,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 1610.0,
		"rentCalcSqm": 23.5036,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8811,
		"y": 60.1522
	},
	{
		"id": 94069,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hirninkuja 1",
		"postalCode": "03100",
		"city": "Nummela",
		"livingArea": 60.0,
		"yearOfConstruction": 1985,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 699.0,
		"rentCalcSqm": 11.65,
		"owner": "Heimstaden FI Resi 08 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 24.2959,
		"y": 60.3417
	},
	{
		"id": 7115,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Melkonkatu 22",
		"postalCode": "2",
		"city": "Helsinki",
		"livingArea": 235.4,
		"yearOfConstruction": 2019,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 1610.0,
		"rentCalcSqm": 6.8394,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8811,
		"y": 60.1522
	},
	{
		"id": 7116,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Meesakatu 5",
		"postalCode": "330",
		"city": "Tampere",
		"livingArea": 21.5,
		"yearOfConstruction": 2019,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 595.0,
		"rentCalcSqm": 27.6744,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 23.6811,
		"y": 61.5219
	},
	{
		"id": 7117,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Meesakatu 5",
		"postalCode": "330",
		"city": "Tampere",
		"livingArea": 68.0,
		"yearOfConstruction": 2019,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 595.0,
		"rentCalcSqm": 8.75,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 23.6811,
		"y": 61.5219
	},
	{
		"id": 7118,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Laurinkuja 6",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 16.5,
		"yearOfConstruction": 2021,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 785.0,
		"rentCalcSqm": 47.5758,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4213,
		"y": 60.9823
	},
	{
		"id": 94773,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Limingantie 2",
		"postalCode": "90400",
		"city": "Oulu",
		"livingArea": 23.0,
		"yearOfConstruction": 2018,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 569.0,
		"rentCalcSqm": 24.7391,
		"owner": "OP-Vuokratuotto -erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4625,
		"y": 65.0024
	},
	{
		"id": 7119,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Melkonkatu 22",
		"postalCode": "2",
		"city": "Helsinki",
		"livingArea": 152.6,
		"yearOfConstruction": 2019,
		"numberOfRooms": null,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 1610.0,
		"rentCalcSqm": 10.5505,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8811,
		"y": 60.1522
	},
	{
		"id": 7120,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 695.0,
		"rentCalcSqm": 14.6316,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7121,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Puolaharju 45",
		"postalCode": "9",
		"city": "Helsinki",
		"livingArea": 173.15,
		"yearOfConstruction": null,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 1704.05,
		"rentCalcSqm": 9.8415,
		"owner": "Keskinäinen Työeläkevakuutusyhtiö Elo",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 25.081,
		"y": 60.2024
	},
	{
		"id": 95298,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Topeliuksenkatu 41",
		"postalCode": "00250",
		"city": "Helsinki",
		"livingArea": 59.0,
		"yearOfConstruction": 2019,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 1331.0,
		"rentCalcSqm": 22.5593,
		"owner": "S-Pankki Asunto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 24.9122,
		"y": 60.1896
	},
	{
		"id": 7122,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 685.0,
		"rentCalcSqm": 14.4211,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7123,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 43.0,
		"yearOfConstruction": 2015,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 884.0,
		"rentCalcSqm": 20.5581,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 95566,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hannunpiha 4",
		"postalCode": "21120",
		"city": "Raisio",
		"livingArea": 81.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 1083.0,
		"rentCalcSqm": 13.2883,
		"owner": "Keskinäinen Työeläkevakuutusyhtiö Elo",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 22.1005,
		"y": 60.4678
	},
	{
		"id": 15,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Lähteenkatu 2",
		"postalCode": "48600",
		"city": "Kotka",
		"livingArea": 64.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 690.0,
		"rentCalcSqm": 10.7813,
		"owner": "Kiinteistömaailma Kotka | Kotkan Laatukoti Oy",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": true,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 26.9306,
		"y": 60.5188
	},
	{
		"id": 16,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Osuustie 4",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 40.5,
		"yearOfConstruction": 2007,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 825.0,
		"rentCalcSqm": 20.3704,
		"owner": "Kodit.io | Homerun Technologies Oy",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": true,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 24.9517,
		"y": 60.2905
	},
	{
		"id": 7124,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 34.5,
		"yearOfConstruction": 2015,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 832.0,
		"rentCalcSqm": 24.1159,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 7125,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 35.5,
		"yearOfConstruction": 2015,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 791.0,
		"rentCalcSqm": 22.2817,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 7126,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 63.5,
		"yearOfConstruction": 2015,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 1082.0,
		"rentCalcSqm": 17.0394,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 7127,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 65.5,
		"yearOfConstruction": 2015,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 1167.0,
		"rentCalcSqm": 17.8168,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 7128,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 45.5,
		"yearOfConstruction": 2015,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 936.0,
		"rentCalcSqm": 20.5714,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 7129,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 35.5,
		"yearOfConstruction": 2015,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 790.0,
		"rentCalcSqm": 22.2535,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 87299,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Jaamantie 23",
		"postalCode": "70150",
		"city": "Kuopio",
		"livingArea": 49.0,
		"yearOfConstruction": 1987,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 584.0,
		"rentCalcSqm": 11.9184,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6026,
		"y": 62.8928
	},
	{
		"id": 101772,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Piirukuja 2",
		"postalCode": "55610",
		"city": "Imatra",
		"livingArea": 59.5,
		"yearOfConstruction": 1976,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 555.0,
		"rentCalcSqm": 9.3277,
		"owner": "Olo Asunnot 4 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 28.795,
		"y": 61.1678
	},
	{
		"id": 7130,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 36.5,
		"yearOfConstruction": 2015,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 791.0,
		"rentCalcSqm": 21.6712,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 14438,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Agricolankuja 6",
		"postalCode": "00530",
		"city": "Helsinki",
		"livingArea": 25.0,
		"yearOfConstruction": 1929,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 835.0,
		"rentCalcSqm": 33.4,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-10-05T21:30:35Z",
		"x": 24.9538,
		"y": 60.1849
	},
	{
		"id": 7131,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 35.5,
		"yearOfConstruction": 2015,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 822.0,
		"rentCalcSqm": 23.1549,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 96905,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Norkkokuja 1",
		"postalCode": "01360",
		"city": "Vantaa",
		"livingArea": 54.0,
		"yearOfConstruction": 2021,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 999.0,
		"rentCalcSqm": 18.5,
		"owner": "Oivat Kaupunkikodit Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.0545,
		"y": 60.3232
	},
	{
		"id": 7132,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 45.5,
		"yearOfConstruction": 2015,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 926.0,
		"rentCalcSqm": 20.3516,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 7133,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 65.5,
		"yearOfConstruction": 2015,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 1207.0,
		"rentCalcSqm": 18.4275,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 15435,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Laamannintie 1",
		"postalCode": "90650",
		"city": "Oulu",
		"livingArea": 30.5,
		"yearOfConstruction": 2012,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 539.0,
		"rentCalcSqm": 17.6721,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-10-05T21:30:35Z",
		"x": 25.5114,
		"y": 65.0243
	},
	{
		"id": 7134,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 685.0,
		"rentCalcSqm": 14.4211,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 16209,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Nahkurintie 3",
		"postalCode": "04300",
		"city": "Tuusula",
		"livingArea": 46.0,
		"yearOfConstruction": null,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 650.0,
		"rentCalcSqm": 14.1304,
		"owner": "Tuija Ukonmäki Oy LKV Isännöintipalvelut",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-10-12T21:30:31Z",
		"x": 25.0199,
		"y": 60.401
	},
	{
		"id": 99584,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Maauuninkuja 6",
		"postalCode": "01450",
		"city": "Vantaa",
		"livingArea": 61.5,
		"yearOfConstruction": 1975,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 934.0,
		"rentCalcSqm": 15.187,
		"owner": "Keskinäinen Työeläkevakuutusyhtiö Elo",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.0641,
		"y": 60.3459
	},
	{
		"id": 7135,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 685.0,
		"rentCalcSqm": 14.4211,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 17815,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "row",
		"address": "Rapamäentie 23",
		"postalCode": "13500",
		"city": "Hämeenlinna",
		"livingArea": 59.0,
		"yearOfConstruction": 1986,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 795.0,
		"rentCalcSqm": 13.4746,
		"owner": "Vuokraturva Oy LKV [A]",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": true,
		"observationTime": "2021-10-19T21:30:09Z",
		"x": 24.4259,
		"y": 60.9862
	},
	{
		"id": 101753,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Piirukuja 2",
		"postalCode": "55610",
		"city": "Imatra",
		"livingArea": 59.5,
		"yearOfConstruction": 1976,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 555.0,
		"rentCalcSqm": 9.3277,
		"owner": "Olo Asunnot 4 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 28.795,
		"y": 61.1678
	},
	{
		"id": 17,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Kokinpellonraitti 1",
		"postalCode": "33870",
		"city": "Tampere",
		"livingArea": 42.5,
		"yearOfConstruction": 2017,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 655.0,
		"rentCalcSqm": 15.4118,
		"owner": "OVV Asuntopalvelut Tampere LVV Oy",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 23.8129,
		"y": 61.432
	},
	{
		"id": 100820,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Jontikka 2",
		"postalCode": "40100",
		"city": "Jyväskylä",
		"livingArea": 52.0,
		"yearOfConstruction": 2011,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 779.0,
		"rentCalcSqm": 14.9808,
		"owner": "CWE Finland 01 Holding Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7599,
		"y": 62.2374
	},
	{
		"id": 7136,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 685.0,
		"rentCalcSqm": 14.4211,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7137,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 685.0,
		"rentCalcSqm": 14.4211,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7138,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 685.0,
		"rentCalcSqm": 14.4211,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 18,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Neilikkatie 25",
		"postalCode": "01300",
		"city": "Vantaa",
		"livingArea": 21.0,
		"yearOfConstruction": 2016,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 685.0,
		"rentCalcSqm": 32.619,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 25.0283,
		"y": 60.2911
	},
	{
		"id": 19,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Kerkkäkatu 5",
		"postalCode": "40530",
		"city": "Jyväskylä",
		"livingArea": 44.0,
		"yearOfConstruction": 2016,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 625.0,
		"rentCalcSqm": 14.2045,
		"owner": "Realia Asuntovuokraus Jyväskylä, Suuromistajien vuokra-asunnot",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": true,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 25.7059,
		"y": 62.1889
	},
	{
		"id": 7139,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 685.0,
		"rentCalcSqm": 14.4211,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 20,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Teljänkuja 2",
		"postalCode": "28130",
		"city": "Pori",
		"livingArea": 34.0,
		"yearOfConstruction": 2014,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 550.0,
		"rentCalcSqm": 16.1765,
		"owner": "Vuokrakumppanit Oy | OVV Asuntopalvelut",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": true,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 21.8002,
		"y": 61.4802
	},
	{
		"id": 7140,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 685.0,
		"rentCalcSqm": 14.4211,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 102180,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Parkkarilankatu 28",
		"postalCode": "53200",
		"city": "Lappeenranta",
		"livingArea": 64.0,
		"yearOfConstruction": 1970,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 698.0,
		"rentCalcSqm": 10.9063,
		"owner": "Olo Asunnot 6 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 28.2312,
		"y": 61.0603
	},
	{
		"id": 7141,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 685.0,
		"rentCalcSqm": 14.4211,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7142,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 43.0,
		"yearOfConstruction": 2015,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 874.0,
		"rentCalcSqm": 20.3256,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 7143,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 25.0,
		"yearOfConstruction": 2020,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 500.0,
		"rentCalcSqm": 20.0,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7144,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 36.5,
		"yearOfConstruction": 2015,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 780.0,
		"rentCalcSqm": 21.3699,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 22070,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Kaarretie 14",
		"postalCode": "90500",
		"city": "Oulu",
		"livingArea": 30.0,
		"yearOfConstruction": 2021,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 530.0,
		"rentCalcSqm": 17.6667,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-11-09T21:30:32Z",
		"x": 25.482,
		"y": 65.0274
	},
	{
		"id": 21,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Hanhitie 13",
		"postalCode": "90150",
		"city": "Oulu",
		"livingArea": 46.5,
		"yearOfConstruction": 2016,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 795.0,
		"rentCalcSqm": 17.0968,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": true,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 25.4968,
		"y": 64.9976
	},
	{
		"id": 7145,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 35.5,
		"yearOfConstruction": 2015,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 822.0,
		"rentCalcSqm": 23.1549,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 103588,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Paturintie 19",
		"postalCode": "28610",
		"city": "Pori",
		"livingArea": 73.0,
		"yearOfConstruction": 1974,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 589.0,
		"rentCalcSqm": 8.0685,
		"owner": "Olo Asunnot 4 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.7371,
		"y": 61.4841
	},
	{
		"id": 22837,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "row",
		"address": "Särkikuja 2",
		"postalCode": "73100",
		"city": "Lapinlahti",
		"livingArea": 34.5,
		"yearOfConstruction": 1982,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 360.0,
		"rentCalcSqm": 10.4348,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": true,
		"observationTime": "2021-11-16T21:30:27Z",
		"x": 27.3939,
		"y": 63.3511
	},
	{
		"id": 104448,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suolaketie 6",
		"postalCode": "06400",
		"city": "Porvoo",
		"livingArea": 76.0,
		"yearOfConstruction": 1975,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 860.0,
		"rentCalcSqm": 11.3158,
		"owner": "Olo Asunnot 5 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6307,
		"y": 60.3735
	},
	{
		"id": 7146,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 34.5,
		"yearOfConstruction": 2015,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 832.0,
		"rentCalcSqm": 24.1159,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 22,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Kopenkatu 2",
		"postalCode": "21110",
		"city": "Naantali",
		"livingArea": 33.0,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 660.0,
		"rentCalcSqm": 20.0,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 22.0329,
		"y": 60.4623
	},
	{
		"id": 23,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Kuokkamaantie 9",
		"postalCode": "33800",
		"city": "Tampere",
		"livingArea": 38.0,
		"yearOfConstruction": 1948,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 580.0,
		"rentCalcSqm": 15.2632,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 23.7802,
		"y": 61.4825
	},
	{
		"id": 24,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Pohjolankatu 19",
		"postalCode": "96100",
		"city": "Rovaniemi",
		"livingArea": 22.0,
		"yearOfConstruction": null,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 425.0,
		"rentCalcSqm": 19.3182,
		"owner": "Rovaniemen Kotipesä Oy",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 25.7152,
		"y": 66.5023
	},
	{
		"id": 7147,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 36.5,
		"yearOfConstruction": 2015,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 780.0,
		"rentCalcSqm": 21.3699,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 105140,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Sepänkatu 6",
		"postalCode": "26100",
		"city": "Rauma",
		"livingArea": 66.0,
		"yearOfConstruction": 1968,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 675.0,
		"rentCalcSqm": 10.2273,
		"owner": "Olo Asunnot 3 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.5028,
		"y": 61.1164
	},
	{
		"id": 24708,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Vapaudenkatu 10",
		"postalCode": "40100",
		"city": "Jyväskylä",
		"livingArea": 24.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 560.0,
		"rentCalcSqm": 22.8571,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-11-23T21:30:18Z",
		"x": 25.7391,
		"y": 62.2362
	},
	{
		"id": 24772,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Kuurintie 2",
		"postalCode": "29600",
		"city": "Pori",
		"livingArea": 59.5,
		"yearOfConstruction": 1981,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 495.0,
		"rentCalcSqm": 8.3193,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-11-23T21:30:18Z",
		"x": 21.8671,
		"y": 61.5923
	},
	{
		"id": 104414,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kirkkokatu 15",
		"postalCode": "87100",
		"city": "Kajaani",
		"livingArea": 58.0,
		"yearOfConstruction": 1960,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 799.0,
		"rentCalcSqm": 13.7759,
		"owner": "Olo Asunnot 4 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.7247,
		"y": 64.2238
	},
	{
		"id": 105809,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pihkapolku 1",
		"postalCode": "48350",
		"city": "Kotka",
		"livingArea": 23.0,
		"yearOfConstruction": 1968,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 295.0,
		"rentCalcSqm": 12.8261,
		"owner": "ERIF II Fin Holdco 1 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 26.8654,
		"y": 60.4823
	},
	{
		"id": 25409,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Tasbyntie 11",
		"postalCode": "01150",
		"city": "Sipoo",
		"livingArea": 78.0,
		"yearOfConstruction": 2018,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 1250.0,
		"rentCalcSqm": 16.0256,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": true,
		"observationTime": "2021-11-23T21:30:18Z",
		"x": 25.3354,
		"y": 60.3071
	},
	{
		"id": 107849,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Tervakukkatie 12",
		"postalCode": "90580",
		"city": "Oulu",
		"livingArea": 43.5,
		"yearOfConstruction": 2000,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 439.0,
		"rentCalcSqm": 10.092,
		"owner": "Riihi säätiö sr",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4171,
		"y": 65.0672
	},
	{
		"id": 7148,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 695.0,
		"rentCalcSqm": 14.6316,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 25993,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Ilveskatu 1",
		"postalCode": "15950",
		"city": "Lahti",
		"livingArea": 31.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 475.0,
		"rentCalcSqm": 15.0794,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-11-30T21:30:05Z",
		"x": 25.5903,
		"y": 61.007
	},
	{
		"id": 107854,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Sammonkatu 3",
		"postalCode": "90570",
		"city": "Oulu",
		"livingArea": 75.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 730.0,
		"rentCalcSqm": 9.6689,
		"owner": "Riihi säätiö sr",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.48,
		"y": 65.0589
	},
	{
		"id": 7149,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 35.5,
		"yearOfConstruction": 2015,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 822.0,
		"rentCalcSqm": 23.1549,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 7150,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 35.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 605.0,
		"rentCalcSqm": 17.0423,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7151,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 46.0,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 650.0,
		"rentCalcSqm": 14.1304,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 25,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Sarvijaakonkatu 23",
		"postalCode": "33540",
		"city": "Tampere",
		"livingArea": 25.0,
		"yearOfConstruction": 2018,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 630.0,
		"rentCalcSqm": 25.2,
		"owner": "Asuntopehtoori LKV",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 23.8126,
		"y": 61.4931
	},
	{
		"id": 7152,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 680.0,
		"rentCalcSqm": 14.3158,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7153,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 680.0,
		"rentCalcSqm": 14.3158,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7154,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 680.0,
		"rentCalcSqm": 14.3158,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7155,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 690.0,
		"rentCalcSqm": 14.5263,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7156,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 690.0,
		"rentCalcSqm": 14.5263,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 26,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Hakaniemen Torikatu 2",
		"postalCode": "00530",
		"city": "Helsinki",
		"livingArea": 55.0,
		"yearOfConstruction": 1907,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 1290.0,
		"rentCalcSqm": 23.4545,
		"owner": "Vuokraturva Oy LKV [A]",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 24.952,
		"y": 60.1803
	},
	{
		"id": 7157,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 35.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 605.0,
		"rentCalcSqm": 17.0423,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7158,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 690.0,
		"rentCalcSqm": 14.5263,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7159,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 35.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 605.0,
		"rentCalcSqm": 17.0423,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 27,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Vanha Viertotie 13",
		"postalCode": "00350",
		"city": "Helsinki",
		"livingArea": 43.5,
		"yearOfConstruction": 1968,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 990.0,
		"rentCalcSqm": 22.7586,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 24.8847,
		"y": 60.2107
	},
	{
		"id": 28,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Simpuntie 5",
		"postalCode": "90830",
		"city": "Oulu",
		"livingArea": 75.0,
		"yearOfConstruction": 1986,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 720.0,
		"rentCalcSqm": 9.6,
		"owner": "Sivakka",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 25.3557,
		"y": 65.1739
	},
	{
		"id": 29,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Vakka 4",
		"postalCode": "04400",
		"city": "Järvenpää",
		"livingArea": 28.0,
		"yearOfConstruction": 2015,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 620.0,
		"rentCalcSqm": 22.1429,
		"owner": "Vuokraturva Oy LKV [A]",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 25.0974,
		"y": 60.4595
	},
	{
		"id": 7160,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 690.0,
		"rentCalcSqm": 14.5263,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 108860,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hämeentie 5",
		"postalCode": "00530",
		"city": "Helsinki",
		"livingArea": 61.5,
		"yearOfConstruction": 1989,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 1131.0,
		"rentCalcSqm": 18.3902,
		"owner": "Nordea Henkivakuutus Suomi Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 24.9541,
		"y": 60.1812
	},
	{
		"id": 7161,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 25.0,
		"yearOfConstruction": 2020,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 500.0,
		"rentCalcSqm": 20.0,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 30,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Kivisaarentie 4",
		"postalCode": "00960",
		"city": "Helsinki",
		"livingArea": 23.5,
		"yearOfConstruction": 1965,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 655.0,
		"rentCalcSqm": 27.8723,
		"owner": "Asuntopehtoori Uusimaa Oy",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 25.139,
		"y": 60.2193
	},
	{
		"id": 7162,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 695.0,
		"rentCalcSqm": 14.6316,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 30203,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "row",
		"address": "Ahmankuja 2",
		"postalCode": "90830",
		"city": "Oulu",
		"livingArea": 98.5,
		"yearOfConstruction": 1993,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 929.0,
		"rentCalcSqm": 9.4315,
		"owner": "Sivakka",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": true,
		"observationTime": "2021-12-21T21:30:04Z",
		"x": 25.3425,
		"y": 65.173
	},
	{
		"id": 30257,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Kansikatu 8",
		"postalCode": "33100",
		"city": "Tampere",
		"livingArea": 26.0,
		"yearOfConstruction": 2020,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 720.0,
		"rentCalcSqm": 27.6923,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-12-21T21:30:04Z",
		"x": 23.7726,
		"y": 61.4936
	},
	{
		"id": 30573,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Pyhtäänkorventie 21",
		"postalCode": "01530",
		"city": "Vantaa",
		"livingArea": 45.5,
		"yearOfConstruction": 2011,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 915.0,
		"rentCalcSqm": 20.1099,
		"owner": "Lumo-kotikeskus PKS",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-12-28T21:30:17Z",
		"x": 24.9757,
		"y": 60.3002
	},
	{
		"id": 30930,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Takahuhdinkatu 75",
		"postalCode": "33560",
		"city": "Tampere",
		"livingArea": 78.0,
		"yearOfConstruction": 1972,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 849.0,
		"rentCalcSqm": 10.8846,
		"owner": "Vuokraturva Oy LKV [A]",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-12-28T21:30:17Z",
		"x": 23.855,
		"y": 61.4923
	},
	{
		"id": 110691,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Tavintie 9",
		"postalCode": "40400",
		"city": "Jyväskylä",
		"livingArea": 54.0,
		"yearOfConstruction": 1975,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 665.0,
		"rentCalcSqm": 12.3148,
		"owner": "Olo Asunnot 1 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7838,
		"y": 62.2454
	},
	{
		"id": 7163,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 695.0,
		"rentCalcSqm": 14.6316,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 31348,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Mallaskatu 16",
		"postalCode": "20760",
		"city": "Kaarina",
		"livingArea": 30.0,
		"yearOfConstruction": 2019,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 7,
		"rentCalc": 525.0,
		"rentCalcSqm": 17.5,
		"owner": "Vuokraturva Oy LKV [A]",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-12-28T21:30:17Z",
		"x": 22.3245,
		"y": 60.411
	},
	{
		"id": 7164,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 690.0,
		"rentCalcSqm": 14.5263,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 31592,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Keltamotie 39",
		"postalCode": "01300",
		"city": "Vantaa",
		"livingArea": 42.5,
		"yearOfConstruction": 2019,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 850.0,
		"rentCalcSqm": 20.0,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-12-28T21:30:17Z",
		"x": 25.0272,
		"y": 60.2961
	},
	{
		"id": 7165,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 695.0,
		"rentCalcSqm": 14.6316,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7166,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 690.0,
		"rentCalcSqm": 14.5263,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7167,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 690.0,
		"rentCalcSqm": 14.5263,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7168,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 690.0,
		"rentCalcSqm": 14.5263,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 7169,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Säterinkatu 14",
		"postalCode": "20",
		"city": "Espoo",
		"livingArea": 37.0,
		"yearOfConstruction": 2015,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 780.0,
		"rentCalcSqm": 21.0811,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.8035,
		"y": 60.214
	},
	{
		"id": 7170,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hilpinkuja 3",
		"postalCode": "130",
		"city": "Hämeenlinna",
		"livingArea": 47.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 685.0,
		"rentCalcSqm": 14.4211,
		"owner": "OP-Palvelukiinteistöt - erikoissijoitusrahasto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-08-31T00:00:00Z",
		"x": 24.4858,
		"y": 60.9973
	},
	{
		"id": 87300,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Jaamantie 23",
		"postalCode": "70150",
		"city": "Kuopio",
		"livingArea": 53.5,
		"yearOfConstruction": 1987,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 605.0,
		"rentCalcSqm": 11.3084,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6026,
		"y": 62.8928
	},
	{
		"id": 32355,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 10",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 53.0,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 745.0,
		"rentCalcSqm": 14.0566,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6631,
		"y": 60.9863
	},
	{
		"id": 32356,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 10",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 79.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 1020.0,
		"rentCalcSqm": 12.8302,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6631,
		"y": 60.9863
	},
	{
		"id": 87301,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Jaamantie 23",
		"postalCode": "70150",
		"city": "Kuopio",
		"livingArea": 36.5,
		"yearOfConstruction": 1987,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 517.0,
		"rentCalcSqm": 14.1644,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6026,
		"y": 62.8928
	},
	{
		"id": 113265,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Itäinen Rantakatu 74",
		"postalCode": "20810",
		"city": "Turku",
		"livingArea": 79.5,
		"yearOfConstruction": 2017,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 1350.0,
		"rentCalcSqm": 16.9811,
		"owner": "IC Kodit RPF II",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 22.2422,
		"y": 60.437
	},
	{
		"id": 1463,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Satamasaarentie 5",
		"postalCode": "9",
		"city": "Helsinki",
		"livingArea": 66.0,
		"yearOfConstruction": 2019,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 1178.0,
		"rentCalcSqm": 17.8485,
		"owner": "Erikoissijoitusrahasto UB Suomi Kiinteistöt",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-07-31T00:00:00Z",
		"x": 25.1386,
		"y": 60.2126
	},
	{
		"id": 34639,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Kasarmintie 12",
		"postalCode": "90130",
		"city": "Oulu",
		"livingArea": 24.0,
		"yearOfConstruction": 2018,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 550.0,
		"rentCalcSqm": 22.9167,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2022-01-11T21:30:17Z",
		"x": 25.4881,
		"y": 65.0198
	},
	{
		"id": 35240,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Ristiaallokonkatu 6",
		"postalCode": "02320",
		"city": "Espoo",
		"livingArea": 60.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 895.0,
		"rentCalcSqm": 14.7934,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2022-01-17T12:43:51Z",
		"x": 24.642,
		"y": 60.1539
	},
	{
		"id": 114014,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kankurinpolku 2",
		"postalCode": "04200",
		"city": "Kerava",
		"livingArea": 69.5,
		"yearOfConstruction": 2020,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 1146.0,
		"rentCalcSqm": 16.4892,
		"owner": "ICECAPITAL Housing Fund V Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.0848,
		"y": 60.4091
	},
	{
		"id": 32360,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 10",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 51.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 730.0,
		"rentCalcSqm": 14.1748,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6631,
		"y": 60.9863
	},
	{
		"id": 35735,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Heikinkatu 6",
		"postalCode": "90100",
		"city": "Oulu",
		"livingArea": 24.5,
		"yearOfConstruction": 2021,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 525.0,
		"rentCalcSqm": 21.4286,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2022-01-17T12:43:51Z",
		"x": 25.4782,
		"y": 65.0149
	},
	{
		"id": 114325,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kaislatie 32",
		"postalCode": "01300",
		"city": "Vantaa",
		"livingArea": 33.5,
		"yearOfConstruction": 2010,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 819.0,
		"rentCalcSqm": 24.4478,
		"owner": "Asunto Lily Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.0212,
		"y": 60.2905
	},
	{
		"id": 35761,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Jouppilantie 13",
		"postalCode": "60320",
		"city": "Seinäjoki",
		"livingArea": 41.5,
		"yearOfConstruction": 2019,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 630.0,
		"rentCalcSqm": 15.1807,
		"owner": "FinCap Vuokrauspalvelu Oy",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": true,
		"observationTime": "2022-01-17T12:43:51Z",
		"x": 22.8199,
		"y": 62.7885
	},
	{
		"id": 114837,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Rauhankatu 2",
		"postalCode": "15110",
		"city": "Lahti",
		"livingArea": 36.5,
		"yearOfConstruction": 1945,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 599.0,
		"rentCalcSqm": 16.411,
		"owner": "A1 AH 2 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6524,
		"y": 60.9809
	},
	{
		"id": 32357,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 10",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 51.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 745.0,
		"rentCalcSqm": 14.466,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6631,
		"y": 60.9863
	},
	{
		"id": 32358,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 10",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 53.0,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 745.0,
		"rentCalcSqm": 14.0566,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6631,
		"y": 60.9863
	},
	{
		"id": 87302,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hautalahdenkatu 1",
		"postalCode": "70820",
		"city": "Kuopio",
		"livingArea": 46.0,
		"yearOfConstruction": 1994,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 575.0,
		"rentCalcSqm": 12.5,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6698,
		"y": 62.8342
	},
	{
		"id": 32326,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 52.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 758.0,
		"rentCalcSqm": 14.4381,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 87353,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Vesijärvenkatu 12",
		"postalCode": "15110",
		"city": "Lahti",
		"livingArea": 85.5,
		"yearOfConstruction": 1963,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 940.0,
		"rentCalcSqm": 10.9942,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6603,
		"y": 60.9811
	},
	{
		"id": 87354,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Vesijärvenkatu 12",
		"postalCode": "15110",
		"city": "Lahti",
		"livingArea": 50.5,
		"yearOfConstruction": 1963,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 699.0,
		"rentCalcSqm": 13.8416,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6603,
		"y": 60.9811
	},
	{
		"id": 32359,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 10",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 79.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 1020.0,
		"rentCalcSqm": 12.8302,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6631,
		"y": 60.9863
	},
	{
		"id": 87303,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Jaamantie 23",
		"postalCode": "70150",
		"city": "Kuopio",
		"livingArea": 53.5,
		"yearOfConstruction": 1987,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 605.0,
		"rentCalcSqm": 11.3084,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6026,
		"y": 62.8928
	},
	{
		"id": 87404,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 60.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 545.0,
		"rentCalcSqm": 9.0083,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 87304,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hautalahdenkatu 1",
		"postalCode": "70820",
		"city": "Kuopio",
		"livingArea": 72.0,
		"yearOfConstruction": 1994,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 770.0,
		"rentCalcSqm": 10.6944,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6698,
		"y": 62.8342
	},
	{
		"id": 1475,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Laajavuorentie 6",
		"postalCode": "16",
		"city": "Vantaa",
		"livingArea": 63.0,
		"yearOfConstruction": 2020,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 1150.0,
		"rentCalcSqm": 18.254,
		"owner": "Erikoissijoitusrahasto UB Suomi Kiinteistöt",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-07-31T00:00:00Z",
		"x": 24.8462,
		"y": 60.2814
	},
	{
		"id": 32361,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 10",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 53.0,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 745.0,
		"rentCalcSqm": 14.0566,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6631,
		"y": 60.9863
	},
	{
		"id": 37118,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Päärtinkatu 4",
		"postalCode": "33560",
		"city": "Tampere",
		"livingArea": 27.0,
		"yearOfConstruction": 2022,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 580.0,
		"rentCalcSqm": 21.4815,
		"owner": "FinCap Vuokrauspalvelu Oy, Tampere",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2022-01-25T21:30:15Z",
		"x": 23.857,
		"y": 61.4898
	},
	{
		"id": 87405,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 79.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 620.0,
		"rentCalcSqm": 7.7987,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 31,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Rautatienkatu 17",
		"postalCode": "90100",
		"city": "Oulu",
		"livingArea": 31.0,
		"yearOfConstruction": 2020,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 7,
		"rentCalc": 600.0,
		"rentCalcSqm": 19.3548,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 25.4813,
		"y": 65.0098
	},
	{
		"id": 37707,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "row",
		"address": "Nikenkuja 3",
		"postalCode": "95410",
		"city": "Tornio",
		"livingArea": 76.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 810.0,
		"rentCalcSqm": 10.6579,
		"owner": "TempNor Group Oy",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": true,
		"observationTime": "2022-01-25T21:30:15Z",
		"x": 24.4714,
		"y": 61.0133
	},
	{
		"id": 32362,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 10",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 79.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 1020.0,
		"rentCalcSqm": 12.8302,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6631,
		"y": 60.9863
	},
	{
		"id": 87406,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 79.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 620.0,
		"rentCalcSqm": 7.7987,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 116802,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Peuraniitty 1",
		"postalCode": "02750",
		"city": "Espoo",
		"livingArea": 55.5,
		"yearOfConstruction": 2021,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 950.0,
		"rentCalcSqm": 17.1171,
		"owner": "S-Pankki Asunto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 24.7379,
		"y": 60.2042
	},
	{
		"id": 32363,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 10",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 51.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 740.0,
		"rentCalcSqm": 14.3689,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6631,
		"y": 60.9863
	},
	{
		"id": 117132,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kukintie 2",
		"postalCode": "01620",
		"city": "Vantaa",
		"livingArea": 31.0,
		"yearOfConstruction": 2018,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 712.0,
		"rentCalcSqm": 22.9677,
		"owner": "S-Pankki Asunto",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 24.8651,
		"y": 60.2778
	},
	{
		"id": 87407,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 60.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 545.0,
		"rentCalcSqm": 9.0083,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 87408,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 33.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 420.0,
		"rentCalcSqm": 12.7273,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 87305,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hautalahdenkatu 1",
		"postalCode": "70820",
		"city": "Kuopio",
		"livingArea": 56.5,
		"yearOfConstruction": 1994,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 655.0,
		"rentCalcSqm": 11.5929,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6698,
		"y": 62.8342
	},
	{
		"id": 32,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Jarrumiehenkatu 3",
		"postalCode": "20100",
		"city": "Turku",
		"livingArea": 41.0,
		"yearOfConstruction": 1967,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 780.0,
		"rentCalcSqm": 19.0244,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 22.2524,
		"y": 60.4516
	},
	{
		"id": 32364,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 67.0,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 871.0,
		"rentCalcSqm": 13.0,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 87306,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hautalahdenkatu 1",
		"postalCode": "70820",
		"city": "Kuopio",
		"livingArea": 72.0,
		"yearOfConstruction": 1994,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 770.0,
		"rentCalcSqm": 10.6944,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6698,
		"y": 62.8342
	},
	{
		"id": 87409,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 79.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 620.0,
		"rentCalcSqm": 7.7987,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 87307,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hautalahdenkatu 1",
		"postalCode": "70820",
		"city": "Kuopio",
		"livingArea": 72.0,
		"yearOfConstruction": 1994,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 770.0,
		"rentCalcSqm": 10.6944,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6698,
		"y": 62.8342
	},
	{
		"id": 33,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Huvilakatu 10",
		"postalCode": "80200",
		"city": "Joensuu",
		"livingArea": 59.0,
		"yearOfConstruction": 1981,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 730.0,
		"rentCalcSqm": 12.3729,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 29.7777,
		"y": 62.5943
	},
	{
		"id": 32365,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 80.0,
		"yearOfConstruction": 1997,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 1020.0,
		"rentCalcSqm": 12.75,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 87308,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hautalahdenkatu 1",
		"postalCode": "70820",
		"city": "Kuopio",
		"livingArea": 56.5,
		"yearOfConstruction": 1994,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 655.0,
		"rentCalcSqm": 11.5929,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6698,
		"y": 62.8342
	},
	{
		"id": 32366,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 53.0,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 745.0,
		"rentCalcSqm": 14.0566,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 32367,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 52.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 740.0,
		"rentCalcSqm": 14.0952,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 32368,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 53.0,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 767.0,
		"rentCalcSqm": 14.4717,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 32369,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 53.0,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 767.0,
		"rentCalcSqm": 14.4717,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 87613,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kappalaisenkatu 5",
		"postalCode": "50170",
		"city": "Mikkeli",
		"livingArea": 61.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 645.0,
		"rentCalcSqm": 10.4878,
		"owner": "Olo Asunnot 12 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.3028,
		"y": 61.7015
	},
	{
		"id": 32371,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 27.5,
		"yearOfConstruction": 1954,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 745.0,
		"rentCalcSqm": 27.0909,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 87309,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hautalahdenkatu 1",
		"postalCode": "70820",
		"city": "Kuopio",
		"livingArea": 72.0,
		"yearOfConstruction": 1994,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 770.0,
		"rentCalcSqm": 10.6944,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6698,
		"y": 62.8342
	},
	{
		"id": 32327,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 53.0,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 745.0,
		"rentCalcSqm": 14.0566,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 87614,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kappalaisenkatu 5",
		"postalCode": "50170",
		"city": "Mikkeli",
		"livingArea": 76.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 745.0,
		"rentCalcSqm": 9.8026,
		"owner": "Olo Asunnot 12 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.3028,
		"y": 61.7015
	},
	{
		"id": 87615,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kappalaisenkatu 5",
		"postalCode": "50170",
		"city": "Mikkeli",
		"livingArea": 76.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 745.0,
		"rentCalcSqm": 9.8026,
		"owner": "Olo Asunnot 12 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.3028,
		"y": 61.7015
	},
	{
		"id": 87310,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hautalahdenkatu 1",
		"postalCode": "70820",
		"city": "Kuopio",
		"livingArea": 56.5,
		"yearOfConstruction": 1994,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 655.0,
		"rentCalcSqm": 11.5929,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6698,
		"y": 62.8342
	},
	{
		"id": 87311,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hautalahdenkatu 1",
		"postalCode": "70820",
		"city": "Kuopio",
		"livingArea": 46.0,
		"yearOfConstruction": 1994,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 575.0,
		"rentCalcSqm": 12.5,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6698,
		"y": 62.8342
	},
	{
		"id": 87312,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hautalahdenkatu 1",
		"postalCode": "70820",
		"city": "Kuopio",
		"livingArea": 43.5,
		"yearOfConstruction": 1994,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 555.0,
		"rentCalcSqm": 12.7586,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6698,
		"y": 62.8342
	},
	{
		"id": 32370,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 28.5,
		"yearOfConstruction": 1954,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 760.0,
		"rentCalcSqm": 26.6667,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 87313,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hautalahdenkatu 1",
		"postalCode": "70820",
		"city": "Kuopio",
		"livingArea": 56.5,
		"yearOfConstruction": 1994,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 655.0,
		"rentCalcSqm": 11.5929,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6698,
		"y": 62.8342
	},
	{
		"id": 32328,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 53.0,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 745.0,
		"rentCalcSqm": 14.0566,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 87355,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Jaamantie 23",
		"postalCode": "70150",
		"city": "Kuopio",
		"livingArea": 58.0,
		"yearOfConstruction": 1987,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 635.0,
		"rentCalcSqm": 10.9483,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6026,
		"y": 62.8928
	},
	{
		"id": 87616,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kappalaisenkatu 5",
		"postalCode": "50170",
		"city": "Mikkeli",
		"livingArea": 76.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 745.0,
		"rentCalcSqm": 9.8026,
		"owner": "Olo Asunnot 12 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.3028,
		"y": 61.7015
	},
	{
		"id": 87617,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kappalaisenkatu 5",
		"postalCode": "50170",
		"city": "Mikkeli",
		"livingArea": 61.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 645.0,
		"rentCalcSqm": 10.4878,
		"owner": "Olo Asunnot 12 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.3028,
		"y": 61.7015
	},
	{
		"id": 87356,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Luiskakatu 3",
		"postalCode": "15500",
		"city": "Lahti",
		"livingArea": 60.0,
		"yearOfConstruction": 1973,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 660.0,
		"rentCalcSqm": 11.0,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6604,
		"y": 60.9604
	},
	{
		"id": 32329,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 78.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 1023.0,
		"rentCalcSqm": 13.0318,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 87618,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kappalaisenkatu 5",
		"postalCode": "50170",
		"city": "Mikkeli",
		"livingArea": 76.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 745.0,
		"rentCalcSqm": 9.8026,
		"owner": "Olo Asunnot 12 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.3028,
		"y": 61.7015
	},
	{
		"id": 32372,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 29.0,
		"yearOfConstruction": 1954,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 760.0,
		"rentCalcSqm": 26.2069,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 32382,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 32.5,
		"yearOfConstruction": 1954,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 827.0,
		"rentCalcSqm": 25.4462,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 32330,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 51.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 740.0,
		"rentCalcSqm": 14.3689,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 87720,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suolaketie 5",
		"postalCode": "06400",
		"city": "Porvoo",
		"livingArea": 61.0,
		"yearOfConstruction": 1975,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 735.0,
		"rentCalcSqm": 12.0492,
		"owner": "Olo Asunnot 12 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.629,
		"y": 60.3739
	},
	{
		"id": 87721,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suolaketie 5",
		"postalCode": "06400",
		"city": "Porvoo",
		"livingArea": 61.0,
		"yearOfConstruction": 1975,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 735.0,
		"rentCalcSqm": 12.0492,
		"owner": "Olo Asunnot 12 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.629,
		"y": 60.3739
	},
	{
		"id": 87357,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Luiskakatu 3",
		"postalCode": "15500",
		"city": "Lahti",
		"livingArea": 60.0,
		"yearOfConstruction": 1973,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 660.0,
		"rentCalcSqm": 11.0,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6604,
		"y": 60.9604
	},
	{
		"id": 32331,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 78.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 1015.0,
		"rentCalcSqm": 12.9299,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 87358,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Aittapellonkatu 4",
		"postalCode": "15170",
		"city": "Lahti",
		"livingArea": 57.5,
		"yearOfConstruction": 1987,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 676.0,
		"rentCalcSqm": 11.7565,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7153,
		"y": 60.9791
	},
	{
		"id": 87757,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suolaketie 5",
		"postalCode": "06400",
		"city": "Porvoo",
		"livingArea": 61.0,
		"yearOfConstruction": 1975,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 735.0,
		"rentCalcSqm": 12.0492,
		"owner": "Olo Asunnot 12 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.629,
		"y": 60.3739
	},
	{
		"id": 32373,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 27.5,
		"yearOfConstruction": 1954,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 745.0,
		"rentCalcSqm": 27.0909,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 32374,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 33.0,
		"yearOfConstruction": 1954,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 810.0,
		"rentCalcSqm": 24.5455,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 32375,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 53.0,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 755.0,
		"rentCalcSqm": 14.2453,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 87758,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suolaketie 5",
		"postalCode": "06400",
		"city": "Porvoo",
		"livingArea": 61.0,
		"yearOfConstruction": 1975,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 735.0,
		"rentCalcSqm": 12.0492,
		"owner": "Olo Asunnot 12 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.629,
		"y": 60.3739
	},
	{
		"id": 32376,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 53.0,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 765.0,
		"rentCalcSqm": 14.434,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 32332,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 53.0,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 771.0,
		"rentCalcSqm": 14.5472,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 87759,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suolaketie 5",
		"postalCode": "06400",
		"city": "Porvoo",
		"livingArea": 35.5,
		"yearOfConstruction": 1975,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 580.0,
		"rentCalcSqm": 16.338,
		"owner": "Olo Asunnot 12 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.629,
		"y": 60.3739
	},
	{
		"id": 32333,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 80.0,
		"yearOfConstruction": 1997,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 1028.0,
		"rentCalcSqm": 12.85,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 87760,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suolaketie 5",
		"postalCode": "06400",
		"city": "Porvoo",
		"livingArea": 79.0,
		"yearOfConstruction": 1975,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 890.0,
		"rentCalcSqm": 11.2658,
		"owner": "Olo Asunnot 12 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.629,
		"y": 60.3739
	},
	{
		"id": 87359,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Aittapellonkatu 4",
		"postalCode": "15170",
		"city": "Lahti",
		"livingArea": 74.0,
		"yearOfConstruction": 1987,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 799.0,
		"rentCalcSqm": 10.7973,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7153,
		"y": 60.9791
	},
	{
		"id": 87761,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suolaketie 5",
		"postalCode": "06400",
		"city": "Porvoo",
		"livingArea": 61.0,
		"yearOfConstruction": 1975,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 735.0,
		"rentCalcSqm": 12.0492,
		"owner": "Olo Asunnot 12 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.629,
		"y": 60.3739
	},
	{
		"id": 87762,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suolaketie 5",
		"postalCode": "06400",
		"city": "Porvoo",
		"livingArea": 61.0,
		"yearOfConstruction": 1975,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 735.0,
		"rentCalcSqm": 12.0492,
		"owner": "Olo Asunnot 12 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.629,
		"y": 60.3739
	},
	{
		"id": 32377,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 52.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 769.0,
		"rentCalcSqm": 14.6476,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 32334,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 51.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 730.0,
		"rentCalcSqm": 14.1748,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 87360,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Aittapellonkatu 4",
		"postalCode": "15170",
		"city": "Lahti",
		"livingArea": 57.5,
		"yearOfConstruction": 1987,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 676.0,
		"rentCalcSqm": 11.7565,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7153,
		"y": 60.9791
	},
	{
		"id": 32335,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 53.0,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 745.0,
		"rentCalcSqm": 14.0566,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 32336,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 78.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 1029.0,
		"rentCalcSqm": 13.1083,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 87361,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Vesijärvenkatu 12",
		"postalCode": "15110",
		"city": "Lahti",
		"livingArea": 64.5,
		"yearOfConstruction": 1963,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 799.0,
		"rentCalcSqm": 12.3876,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6603,
		"y": 60.9811
	},
	{
		"id": 87362,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Vesijärvenkatu 12",
		"postalCode": "15110",
		"city": "Lahti",
		"livingArea": 40.5,
		"yearOfConstruction": 1963,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 565.0,
		"rentCalcSqm": 13.9506,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6603,
		"y": 60.9811
	},
	{
		"id": 32337,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 51.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 735.0,
		"rentCalcSqm": 14.2718,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 87363,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Aittapellonkatu 4",
		"postalCode": "15170",
		"city": "Lahti",
		"livingArea": 57.5,
		"yearOfConstruction": 1987,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 676.0,
		"rentCalcSqm": 11.7565,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7153,
		"y": 60.9791
	},
	{
		"id": 32378,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 25.5,
		"yearOfConstruction": 1954,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 735.0,
		"rentCalcSqm": 28.8235,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 32338,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 53.0,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 745.0,
		"rentCalcSqm": 14.0566,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 87763,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suolaketie 5",
		"postalCode": "06400",
		"city": "Porvoo",
		"livingArea": 61.0,
		"yearOfConstruction": 1975,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 735.0,
		"rentCalcSqm": 12.0492,
		"owner": "Olo Asunnot 12 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.629,
		"y": 60.3739
	},
	{
		"id": 87364,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Aittapellonkatu 4",
		"postalCode": "15170",
		"city": "Lahti",
		"livingArea": 57.5,
		"yearOfConstruction": 1987,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 7,
		"rentCalc": 676.0,
		"rentCalcSqm": 11.7565,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7153,
		"y": 60.9791
	},
	{
		"id": 87764,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Perunakatu 5",
		"postalCode": "70820",
		"city": "Kuopio",
		"livingArea": 43.5,
		"yearOfConstruction": 1993,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 550.0,
		"rentCalcSqm": 12.6437,
		"owner": "Olo Asunnot 11 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6574,
		"y": 62.8354
	},
	{
		"id": 32379,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 32.5,
		"yearOfConstruction": 1954,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 795.0,
		"rentCalcSqm": 24.4615,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 87365,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hautalahdenkatu 1",
		"postalCode": "70820",
		"city": "Kuopio",
		"livingArea": 76.0,
		"yearOfConstruction": 1994,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 805.0,
		"rentCalcSqm": 10.5921,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6698,
		"y": 62.8342
	},
	{
		"id": 32339,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 78.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 1015.0,
		"rentCalcSqm": 12.9299,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 87366,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hautalahdenkatu 1",
		"postalCode": "70820",
		"city": "Kuopio",
		"livingArea": 72.0,
		"yearOfConstruction": 1994,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 750.0,
		"rentCalcSqm": 10.4167,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6698,
		"y": 62.8342
	},
	{
		"id": 87765,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Perunakatu 5",
		"postalCode": "70820",
		"city": "Kuopio",
		"livingArea": 40.5,
		"yearOfConstruction": 1993,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 525.0,
		"rentCalcSqm": 12.963,
		"owner": "Olo Asunnot 11 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6574,
		"y": 62.8354
	},
	{
		"id": 32380,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 27.0,
		"yearOfConstruction": 1954,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 745.0,
		"rentCalcSqm": 27.5926,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 32381,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 32.5,
		"yearOfConstruction": 1954,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 795.0,
		"rentCalcSqm": 24.4615,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 87367,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hautalahdenkatu 1",
		"postalCode": "70820",
		"city": "Kuopio",
		"livingArea": 76.0,
		"yearOfConstruction": 1994,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 805.0,
		"rentCalcSqm": 10.5921,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6698,
		"y": 62.8342
	},
	{
		"id": 87766,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Perunakatu 5",
		"postalCode": "70820",
		"city": "Kuopio",
		"livingArea": 59.0,
		"yearOfConstruction": 1993,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 665.0,
		"rentCalcSqm": 11.2712,
		"owner": "Olo Asunnot 11 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6574,
		"y": 62.8354
	},
	{
		"id": 87368,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Hautalahdenkatu 1",
		"postalCode": "70820",
		"city": "Kuopio",
		"livingArea": 72.0,
		"yearOfConstruction": 1994,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 770.0,
		"rentCalcSqm": 10.6944,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6698,
		"y": 62.8342
	},
	{
		"id": 87410,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 76.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 610.0,
		"rentCalcSqm": 8.0263,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 87767,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pentinpolku 5",
		"postalCode": "71310",
		"city": "Vehmersalmi",
		"livingArea": 58.0,
		"yearOfConstruction": 1991,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 579.0,
		"rentCalcSqm": 9.9828,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.9921,
		"y": 62.7687
	},
	{
		"id": 32383,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 25.5,
		"yearOfConstruction": 1954,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 735.0,
		"rentCalcSqm": 28.8235,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 87768,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pentinpolku 5",
		"postalCode": "71310",
		"city": "Vehmersalmi",
		"livingArea": 58.0,
		"yearOfConstruction": 1991,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 579.0,
		"rentCalcSqm": 9.9828,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.9921,
		"y": 62.7687
	},
	{
		"id": 32384,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 29.0,
		"yearOfConstruction": 1954,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 760.0,
		"rentCalcSqm": 26.2069,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 32385,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 29.0,
		"yearOfConstruction": 1954,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 760.0,
		"rentCalcSqm": 26.2069,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 87769,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pentinpolku 5",
		"postalCode": "71310",
		"city": "Vehmersalmi",
		"livingArea": 71.0,
		"yearOfConstruction": 1991,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 692.0,
		"rentCalcSqm": 9.7465,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.9921,
		"y": 62.7687
	},
	{
		"id": 32386,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 51.0,
		"yearOfConstruction": 1954,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 1060.0,
		"rentCalcSqm": 20.7843,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 32387,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 51.5,
		"yearOfConstruction": 1954,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 1060.0,
		"rentCalcSqm": 20.5825,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 87770,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pentinpolku 5",
		"postalCode": "71310",
		"city": "Vehmersalmi",
		"livingArea": 58.0,
		"yearOfConstruction": 1991,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 579.0,
		"rentCalcSqm": 9.9828,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.9921,
		"y": 62.7687
	},
	{
		"id": 87411,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 33.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 420.0,
		"rentCalcSqm": 12.7273,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 32388,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 51.0,
		"yearOfConstruction": 1954,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 1060.0,
		"rentCalcSqm": 20.7843,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 32389,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 51.5,
		"yearOfConstruction": 1954,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 1060.0,
		"rentCalcSqm": 20.5825,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 32390,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 51.5,
		"yearOfConstruction": 1954,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 1060.0,
		"rentCalcSqm": 20.5825,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 32340,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 51.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 730.0,
		"rentCalcSqm": 14.1748,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 87771,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pentinpolku 5",
		"postalCode": "71310",
		"city": "Vehmersalmi",
		"livingArea": 71.0,
		"yearOfConstruction": 1991,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 692.0,
		"rentCalcSqm": 9.7465,
		"owner": "Olo Asunnot 7 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.9921,
		"y": 62.7687
	},
	{
		"id": 32391,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 32.5,
		"yearOfConstruction": 1954,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 795.0,
		"rentCalcSqm": 24.4615,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 32392,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 51.0,
		"yearOfConstruction": 1954,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 1060.0,
		"rentCalcSqm": 20.7843,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 87412,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 33.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 420.0,
		"rentCalcSqm": 12.7273,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 32393,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 34.5,
		"yearOfConstruction": 1954,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 820.0,
		"rentCalcSqm": 23.7681,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 87413,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Vesijärvenkatu 12",
		"postalCode": "15110",
		"city": "Lahti",
		"livingArea": 85.0,
		"yearOfConstruction": 1963,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 940.0,
		"rentCalcSqm": 11.0588,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6603,
		"y": 60.9811
	},
	{
		"id": 32394,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 32.5,
		"yearOfConstruction": 1954,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 795.0,
		"rentCalcSqm": 24.4615,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 87414,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Ramsayntie 5",
		"postalCode": "07940",
		"city": "Loviisa",
		"livingArea": 59.5,
		"yearOfConstruction": 1973,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 572.0,
		"rentCalcSqm": 9.6134,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 26.2476,
		"y": 60.4592
	},
	{
		"id": 32395,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 29.0,
		"yearOfConstruction": 1954,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 760.0,
		"rentCalcSqm": 26.2069,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 32396,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 29.0,
		"yearOfConstruction": 1954,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 760.0,
		"rentCalcSqm": 26.2069,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 87415,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Ramsayntie 5",
		"postalCode": "07940",
		"city": "Loviisa",
		"livingArea": 91.5,
		"yearOfConstruction": 1973,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 746.0,
		"rentCalcSqm": 8.153,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 26.2476,
		"y": 60.4592
	},
	{
		"id": 32341,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 53.0,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 764.0,
		"rentCalcSqm": 14.4151,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 87416,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 1",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 58.5,
		"yearOfConstruction": 1978,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 565.0,
		"rentCalcSqm": 9.6581,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9892
	},
	{
		"id": 87827,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Luiskakatu 3",
		"postalCode": "15500",
		"city": "Lahti",
		"livingArea": 109.0,
		"yearOfConstruction": 1973,
		"numberOfRooms": 5,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 955.0,
		"rentCalcSqm": 8.7615,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6604,
		"y": 60.9604
	},
	{
		"id": 87417,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 1",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 51.5,
		"yearOfConstruction": 1978,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 540.0,
		"rentCalcSqm": 10.4854,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9892
	},
	{
		"id": 32397,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 25.0,
		"yearOfConstruction": 1954,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 735.0,
		"rentCalcSqm": 29.4,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 87828,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Luiskakatu 3",
		"postalCode": "15500",
		"city": "Lahti",
		"livingArea": 109.0,
		"yearOfConstruction": 1973,
		"numberOfRooms": 5,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 955.0,
		"rentCalcSqm": 8.7615,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6604,
		"y": 60.9604
	},
	{
		"id": 87829,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Luiskakatu 3",
		"postalCode": "15500",
		"city": "Lahti",
		"livingArea": 109.0,
		"yearOfConstruction": 1973,
		"numberOfRooms": 5,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 955.0,
		"rentCalcSqm": 8.7615,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6604,
		"y": 60.9604
	},
	{
		"id": 87418,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 1",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 57.0,
		"yearOfConstruction": 1978,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 550.0,
		"rentCalcSqm": 9.6491,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9892
	},
	{
		"id": 87830,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Vesijärvenkatu 12",
		"postalCode": "15110",
		"city": "Lahti",
		"livingArea": 46.5,
		"yearOfConstruction": 1963,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 645.0,
		"rentCalcSqm": 13.871,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6603,
		"y": 60.9811
	},
	{
		"id": 87831,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Vesijärvenkatu 12",
		"postalCode": "15110",
		"city": "Lahti",
		"livingArea": 64.5,
		"yearOfConstruction": 1963,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 799.0,
		"rentCalcSqm": 12.3876,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6603,
		"y": 60.9811
	},
	{
		"id": 32398,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 51.0,
		"yearOfConstruction": 1954,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 1060.0,
		"rentCalcSqm": 20.7843,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 87832,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Vesijärvenkatu 12",
		"postalCode": "15110",
		"city": "Lahti",
		"livingArea": 85.5,
		"yearOfConstruction": 1963,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 940.0,
		"rentCalcSqm": 10.9942,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6603,
		"y": 60.9811
	},
	{
		"id": 87896,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Mertakaari 30",
		"postalCode": "70800",
		"city": "Kuopio",
		"livingArea": 62.0,
		"yearOfConstruction": 1991,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 660.0,
		"rentCalcSqm": 10.6452,
		"owner": "Olo Asunnot 11 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6393,
		"y": 62.8294
	},
	{
		"id": 87419,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 79.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 620.0,
		"rentCalcSqm": 7.7987,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 87897,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Mertakaari 30",
		"postalCode": "70800",
		"city": "Kuopio",
		"livingArea": 38.0,
		"yearOfConstruction": 1991,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 465.0,
		"rentCalcSqm": 12.2368,
		"owner": "Olo Asunnot 11 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6393,
		"y": 62.8294
	},
	{
		"id": 32399,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 51.5,
		"yearOfConstruction": 1954,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 1060.0,
		"rentCalcSqm": 20.5825,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 87898,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Mertakaari 30",
		"postalCode": "70800",
		"city": "Kuopio",
		"livingArea": 38.0,
		"yearOfConstruction": 1991,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 465.0,
		"rentCalcSqm": 12.2368,
		"owner": "Olo Asunnot 11 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6393,
		"y": 62.8294
	},
	{
		"id": 32400,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 51.0,
		"yearOfConstruction": 1954,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 1060.0,
		"rentCalcSqm": 20.7843,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 87420,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 33.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 420.0,
		"rentCalcSqm": 12.7273,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 87421,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 60.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 545.0,
		"rentCalcSqm": 9.0083,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 32342,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 53.0,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 745.0,
		"rentCalcSqm": 14.0566,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 34,
		"accommodationType": "vapaarahoitteinen",
		"apartmentType": "apartment",
		"address": "Vahentie 3",
		"postalCode": "27510",
		"city": "Eura",
		"livingArea": 55.5,
		"yearOfConstruction": 1976,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": null,
		"rentCalc": 490.0,
		"rentCalcSqm": 8.8288,
		"owner": "private owner",
		"source": "vuokraovi",
		"condition": "hyvä",
		"hasSauna": false,
		"observationTime": "2021-07-27T21:30:28Z",
		"x": 22.1307,
		"y": 61.1282
	},
	{
		"id": 32343,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 92.0,
		"yearOfConstruction": 1997,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 1201.0,
		"rentCalcSqm": 13.0543,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 32401,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 51.5,
		"yearOfConstruction": 1954,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 1060.0,
		"rentCalcSqm": 20.5825,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 32402,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kimmontie 3",
		"postalCode": "00610",
		"city": "Helsinki",
		"livingArea": 33.0,
		"yearOfConstruction": 1954,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 810.0,
		"rentCalcSqm": 24.5455,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 24.9423,
		"y": 60.2107
	},
	{
		"id": 87899,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Mertakaari 30",
		"postalCode": "70800",
		"city": "Kuopio",
		"livingArea": 38.0,
		"yearOfConstruction": 1991,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 465.0,
		"rentCalcSqm": 12.2368,
		"owner": "Olo Asunnot 11 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6393,
		"y": 62.8294
	},
	{
		"id": 87900,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Mertakaari 30",
		"postalCode": "70800",
		"city": "Kuopio",
		"livingArea": 62.0,
		"yearOfConstruction": 1991,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 660.0,
		"rentCalcSqm": 10.6452,
		"owner": "Olo Asunnot 11 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6393,
		"y": 62.8294
	},
	{
		"id": 45085,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 44.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 855.0,
		"rentCalcSqm": 19.4318,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 87422,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 76.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 590.0,
		"rentCalcSqm": 7.7632,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 87423,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 79.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 620.0,
		"rentCalcSqm": 7.7987,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 87901,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Perunakatu 5",
		"postalCode": "70820",
		"city": "Kuopio",
		"livingArea": 40.5,
		"yearOfConstruction": 1993,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 525.0,
		"rentCalcSqm": 12.963,
		"owner": "Olo Asunnot 11 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.6574,
		"y": 62.8354
	},
	{
		"id": 45086,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 74.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 1180.0,
		"rentCalcSqm": 15.8389,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45087,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 57.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 930.0,
		"rentCalcSqm": 16.3158,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 87424,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 79.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 620.0,
		"rentCalcSqm": 7.7987,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 87425,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Ramsayntie 5",
		"postalCode": "07940",
		"city": "Loviisa",
		"livingArea": 91.5,
		"yearOfConstruction": 1973,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 7,
		"rentCalc": 746.0,
		"rentCalcSqm": 8.153,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 26.2476,
		"y": 60.4592
	},
	{
		"id": 87956,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 1",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 57.0,
		"yearOfConstruction": 1978,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 550.0,
		"rentCalcSqm": 9.6491,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9892
	},
	{
		"id": 87426,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 33.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 420.0,
		"rentCalcSqm": 12.7273,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 87427,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 60.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 545.0,
		"rentCalcSqm": 9.0083,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 32344,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 52.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 762.0,
		"rentCalcSqm": 14.5143,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 87957,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 1",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 75.0,
		"yearOfConstruction": 1978,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 675.0,
		"rentCalcSqm": 9.0,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9892
	},
	{
		"id": 45088,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 63.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 960.0,
		"rentCalcSqm": 15.1181,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 87958,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Karhuntie 8",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 79.0,
		"yearOfConstruction": 1967,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 775.0,
		"rentCalcSqm": 9.8101,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6478,
		"y": 63.0824
	},
	{
		"id": 45089,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 58.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 945.0,
		"rentCalcSqm": 16.1538,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45090,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 91.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 1440.0,
		"rentCalcSqm": 15.8242,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 87959,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Karhuntie 8",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 79.0,
		"yearOfConstruction": 1967,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 775.0,
		"rentCalcSqm": 9.8101,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6478,
		"y": 63.0824
	},
	{
		"id": 87428,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 60.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 545.0,
		"rentCalcSqm": 9.0083,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 87960,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Karhuntie 8",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 61.0,
		"yearOfConstruction": 1967,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 655.0,
		"rentCalcSqm": 10.7377,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6478,
		"y": 63.0824
	},
	{
		"id": 45091,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 57.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 925.0,
		"rentCalcSqm": 16.2281,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 32345,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 10",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 92.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 1190.0,
		"rentCalcSqm": 12.8649,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6631,
		"y": 60.9863
	},
	{
		"id": 87961,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Karhuntie 8",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 61.0,
		"yearOfConstruction": 1967,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 7,
		"rentCalc": 655.0,
		"rentCalcSqm": 10.7377,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6478,
		"y": 63.0824
	},
	{
		"id": 87429,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 58.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 525.0,
		"rentCalcSqm": 8.9744,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 87430,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 50.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 499.0,
		"rentCalcSqm": 9.98,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 87431,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 60.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 545.0,
		"rentCalcSqm": 9.0083,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 87432,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 1",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 32.0,
		"yearOfConstruction": 1978,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 0,
		"rentCalc": 440.0,
		"rentCalcSqm": 13.75,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9892
	},
	{
		"id": 45092,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 58.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 950.0,
		"rentCalcSqm": 16.2393,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45093,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 63.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 965.0,
		"rentCalcSqm": 15.1969,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 32346,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 53.0,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 745.0,
		"rentCalcSqm": 14.0566,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 88016,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Karhuntie 8",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 79.0,
		"yearOfConstruction": 1967,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 775.0,
		"rentCalcSqm": 9.8101,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6478,
		"y": 63.0824
	},
	{
		"id": 87433,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 60.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 545.0,
		"rentCalcSqm": 9.0083,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 88017,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Karhuntie 8",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 61.0,
		"yearOfConstruction": 1967,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 655.0,
		"rentCalcSqm": 10.7377,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6478,
		"y": 63.0824
	},
	{
		"id": 87434,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 76.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 610.0,
		"rentCalcSqm": 8.0263,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 32347,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 51.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 754.0,
		"rentCalcSqm": 14.6408,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 45094,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 74.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 1175.0,
		"rentCalcSqm": 15.7718,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45095,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 44.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 850.0,
		"rentCalcSqm": 19.3182,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45096,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 74.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 1180.0,
		"rentCalcSqm": 15.8389,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45098,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 48.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 865.0,
		"rentCalcSqm": 17.8351,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 32348,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 10",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 80.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 1025.0,
		"rentCalcSqm": 12.7329,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6631,
		"y": 60.9863
	},
	{
		"id": 45097,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 74.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 1180.0,
		"rentCalcSqm": 15.8389,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 87435,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 60.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 545.0,
		"rentCalcSqm": 9.0083,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 88018,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Karhuntie 8",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 61.0,
		"yearOfConstruction": 1967,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 655.0,
		"rentCalcSqm": 10.7377,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6478,
		"y": 63.0824
	},
	{
		"id": 32349,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 10",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 79.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 1020.0,
		"rentCalcSqm": 12.8302,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6631,
		"y": 60.9863
	},
	{
		"id": 87436,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 33.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 420.0,
		"rentCalcSqm": 12.7273,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 45099,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 74.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 1180.0,
		"rentCalcSqm": 15.8389,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 32350,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 10",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 51.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 730.0,
		"rentCalcSqm": 14.1748,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6631,
		"y": 60.9863
	},
	{
		"id": 32351,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 10",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 53.0,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 758.0,
		"rentCalcSqm": 14.3019,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6631,
		"y": 60.9863
	},
	{
		"id": 32352,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 10",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 79.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 950.0,
		"rentCalcSqm": 11.9497,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6631,
		"y": 60.9863
	},
	{
		"id": 88019,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Karhuntie 8",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 79.0,
		"yearOfConstruction": 1967,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 775.0,
		"rentCalcSqm": 9.8101,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6478,
		"y": 63.0824
	},
	{
		"id": 32353,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 10",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 51.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 730.0,
		"rentCalcSqm": 14.1748,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6631,
		"y": 60.9863
	},
	{
		"id": 88020,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Karhuntie 8",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 79.0,
		"yearOfConstruction": 1967,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 775.0,
		"rentCalcSqm": 9.8101,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6478,
		"y": 63.0824
	},
	{
		"id": 45079,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 91.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 1460.0,
		"rentCalcSqm": 16.044,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 87437,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 76.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 590.0,
		"rentCalcSqm": 7.7632,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 87438,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 60.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 545.0,
		"rentCalcSqm": 9.0083,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 45080,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 62.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 955.0,
		"rentCalcSqm": 15.28,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 88021,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Karhuntie 8",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 61.0,
		"yearOfConstruction": 1967,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 655.0,
		"rentCalcSqm": 10.7377,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6478,
		"y": 63.0824
	},
	{
		"id": 88095,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pietarsaarenkatu 10",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 90.5,
		"yearOfConstruction": 1973,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 775.0,
		"rentCalcSqm": 8.5635,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6621,
		"y": 63.0711
	},
	{
		"id": 87439,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 33.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 420.0,
		"rentCalcSqm": 12.7273,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 88200,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Louhikkotie 12",
		"postalCode": "96500",
		"city": "Rovaniemi",
		"livingArea": 70.5,
		"yearOfConstruction": 1968,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 705.0,
		"rentCalcSqm": 10.0,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6829,
		"y": 66.5098
	},
	{
		"id": 45081,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 44.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 850.0,
		"rentCalcSqm": 19.3182,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45100,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 74.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 1185.0,
		"rentCalcSqm": 15.906,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45101,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 74.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 1185.0,
		"rentCalcSqm": 15.906,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45102,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 48.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 870.0,
		"rentCalcSqm": 17.9381,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45103,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 74.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 1185.0,
		"rentCalcSqm": 15.906,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 87440,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 76.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 590.0,
		"rentCalcSqm": 7.7632,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 87441,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 60.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 545.0,
		"rentCalcSqm": 9.0083,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 87442,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 33.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 420.0,
		"rentCalcSqm": 12.7273,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 87443,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 33.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 399.0,
		"rentCalcSqm": 12.0909,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 88201,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Louhikkotie 12",
		"postalCode": "96500",
		"city": "Rovaniemi",
		"livingArea": 29.0,
		"yearOfConstruction": 1968,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 480.0,
		"rentCalcSqm": 16.5517,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6829,
		"y": 66.5098
	},
	{
		"id": 87444,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 1",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 75.0,
		"yearOfConstruction": 1978,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 675.0,
		"rentCalcSqm": 9.0,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9892
	},
	{
		"id": 88202,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Aisakuja 1",
		"postalCode": "04440",
		"city": "Järvenpää",
		"livingArea": 78.5,
		"yearOfConstruction": 1984,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 990.0,
		"rentCalcSqm": 12.6115,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.0669,
		"y": 60.4955
	},
	{
		"id": 88203,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Louhikkotie 12",
		"postalCode": "96500",
		"city": "Rovaniemi",
		"livingArea": 56.5,
		"yearOfConstruction": 1968,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 615.0,
		"rentCalcSqm": 10.885,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6829,
		"y": 66.5098
	},
	{
		"id": 88204,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Louhikkotie 12",
		"postalCode": "96500",
		"city": "Rovaniemi",
		"livingArea": 29.0,
		"yearOfConstruction": 1968,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 480.0,
		"rentCalcSqm": 16.5517,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6829,
		"y": 66.5098
	},
	{
		"id": 87445,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 1",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 32.0,
		"yearOfConstruction": 1978,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 450.0,
		"rentCalcSqm": 14.0625,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9892
	},
	{
		"id": 45104,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 48.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 860.0,
		"rentCalcSqm": 17.732,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45082,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 52.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 910.0,
		"rentCalcSqm": 17.3333,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 87446,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 1",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 57.0,
		"yearOfConstruction": 1978,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 550.0,
		"rentCalcSqm": 9.6491,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9892
	},
	{
		"id": 45083,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 74.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 1180.0,
		"rentCalcSqm": 15.8389,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 88205,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Louhikkotie 12",
		"postalCode": "96500",
		"city": "Rovaniemi",
		"livingArea": 56.5,
		"yearOfConstruction": 1968,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 615.0,
		"rentCalcSqm": 10.885,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6829,
		"y": 66.5098
	},
	{
		"id": 45105,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 44.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 850.0,
		"rentCalcSqm": 19.3182,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 87447,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 1",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 51.5,
		"yearOfConstruction": 1978,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 540.0,
		"rentCalcSqm": 10.4854,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9892
	},
	{
		"id": 45106,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 48.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 880.0,
		"rentCalcSqm": 18.1443,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 88206,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Louhikkotie 12",
		"postalCode": "96500",
		"city": "Rovaniemi",
		"livingArea": 70.5,
		"yearOfConstruction": 1968,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 705.0,
		"rentCalcSqm": 10.0,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6829,
		"y": 66.5098
	},
	{
		"id": 87448,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 1",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 58.5,
		"yearOfConstruction": 1978,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 565.0,
		"rentCalcSqm": 9.6581,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9892
	},
	{
		"id": 45107,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 74.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 1180.0,
		"rentCalcSqm": 15.8389,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45084,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 74.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 1180.0,
		"rentCalcSqm": 15.8389,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 53285,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 45.0,
		"yearOfConstruction": 2022,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 14,
		"rentCalc": 890.0,
		"rentCalcSqm": 19.7778,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 87449,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 1",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 57.0,
		"yearOfConstruction": 1978,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 550.0,
		"rentCalcSqm": 9.6491,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9892
	},
	{
		"id": 45108,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 48.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 870.0,
		"rentCalcSqm": 17.9381,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 87450,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Vesijärvenkatu 12",
		"postalCode": "15110",
		"city": "Lahti",
		"livingArea": 65.0,
		"yearOfConstruction": 1963,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 799.0,
		"rentCalcSqm": 12.2923,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6603,
		"y": 60.9811
	},
	{
		"id": 88557,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kuhasalontie 14",
		"postalCode": "80220",
		"city": "Joensuu",
		"livingArea": 60.5,
		"yearOfConstruction": 1974,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 650.0,
		"rentCalcSqm": 10.7438,
		"owner": "Olo Asunnot 14 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 29.7639,
		"y": 62.5839
	},
	{
		"id": 88207,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Louhikkotie 12",
		"postalCode": "96500",
		"city": "Rovaniemi",
		"livingArea": 29.0,
		"yearOfConstruction": 1968,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 480.0,
		"rentCalcSqm": 16.5517,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6829,
		"y": 66.5098
	},
	{
		"id": 87451,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 3",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 90.0,
		"yearOfConstruction": 1974,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 789.0,
		"rentCalcSqm": 8.7667,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9898
	},
	{
		"id": 87452,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 1",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 51.5,
		"yearOfConstruction": 1978,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 540.0,
		"rentCalcSqm": 10.4854,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9892
	},
	{
		"id": 87453,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 33.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 420.0,
		"rentCalcSqm": 12.7273,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 45109,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 58.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 955.0,
		"rentCalcSqm": 16.3248,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 87454,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 3",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 46.5,
		"yearOfConstruction": 1974,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 543.0,
		"rentCalcSqm": 11.6774,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9898
	},
	{
		"id": 87455,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 3",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 57.0,
		"yearOfConstruction": 1974,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 564.0,
		"rentCalcSqm": 9.8947,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9898
	},
	{
		"id": 53304,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 24.5,
		"yearOfConstruction": 2022,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 635.0,
		"rentCalcSqm": 25.9184,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 45110,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 76.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 1190.0,
		"rentCalcSqm": 15.6579,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 53305,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 30.0,
		"yearOfConstruction": 2022,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 7,
		"rentCalc": 700.0,
		"rentCalcSqm": 23.3333,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 45111,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 91.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 1460.0,
		"rentCalcSqm": 16.044,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 88208,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Louhikkotie 12",
		"postalCode": "96500",
		"city": "Rovaniemi",
		"livingArea": 56.5,
		"yearOfConstruction": 1968,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 615.0,
		"rentCalcSqm": 10.885,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6829,
		"y": 66.5098
	},
	{
		"id": 45112,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 54.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 920.0,
		"rentCalcSqm": 16.8807,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 88209,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Louhikkotie 12",
		"postalCode": "96500",
		"city": "Rovaniemi",
		"livingArea": 70.5,
		"yearOfConstruction": 1968,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 705.0,
		"rentCalcSqm": 10.0,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6829,
		"y": 66.5098
	},
	{
		"id": 88210,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Louhikkotie 12",
		"postalCode": "96500",
		"city": "Rovaniemi",
		"livingArea": 29.0,
		"yearOfConstruction": 1968,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 480.0,
		"rentCalcSqm": 16.5517,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6829,
		"y": 66.5098
	},
	{
		"id": 88211,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Louhikkotie 12",
		"postalCode": "96500",
		"city": "Rovaniemi",
		"livingArea": 56.5,
		"yearOfConstruction": 1968,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 615.0,
		"rentCalcSqm": 10.885,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6829,
		"y": 66.5098
	},
	{
		"id": 53306,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 30.0,
		"yearOfConstruction": 2022,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 7,
		"rentCalc": 700.0,
		"rentCalcSqm": 23.3333,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 45113,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 88.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 1430.0,
		"rentCalcSqm": 16.1582,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 88212,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Porokatu 37",
		"postalCode": "96400",
		"city": "Rovaniemi",
		"livingArea": 22.0,
		"yearOfConstruction": 1966,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 419.0,
		"rentCalcSqm": 19.0455,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7718,
		"y": 66.494
	},
	{
		"id": 45114,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 62.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 955.0,
		"rentCalcSqm": 15.28,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 53307,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 41.0,
		"yearOfConstruction": 2022,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 7,
		"rentCalc": 830.0,
		"rentCalcSqm": 20.2439,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 53308,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 66.5,
		"yearOfConstruction": 2022,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 7,
		"rentCalc": 1295.0,
		"rentCalcSqm": 19.4737,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 45115,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 59.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 935.0,
		"rentCalcSqm": 15.8475,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45116,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 52.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 910.0,
		"rentCalcSqm": 17.3333,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 53309,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 51.5,
		"yearOfConstruction": 2022,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 7,
		"rentCalc": 1080.0,
		"rentCalcSqm": 20.9709,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 45117,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 57.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 930.0,
		"rentCalcSqm": 16.3158,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45118,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 54.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 920.0,
		"rentCalcSqm": 16.8807,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45119,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 88.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 1440.0,
		"rentCalcSqm": 16.2712,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 88213,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Louhikkotie 12",
		"postalCode": "96500",
		"city": "Rovaniemi",
		"livingArea": 70.5,
		"yearOfConstruction": 1968,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 705.0,
		"rentCalcSqm": 10.0,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6829,
		"y": 66.5098
	},
	{
		"id": 87538,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 33.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 420.0,
		"rentCalcSqm": 12.7273,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 45120,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 76.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 1190.0,
		"rentCalcSqm": 15.6579,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 53310,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 32.0,
		"yearOfConstruction": 2022,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 7,
		"rentCalc": 735.0,
		"rentCalcSqm": 22.9688,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 88214,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Porokatu 37",
		"postalCode": "96400",
		"city": "Rovaniemi",
		"livingArea": 22.0,
		"yearOfConstruction": 1966,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 419.0,
		"rentCalcSqm": 19.0455,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7718,
		"y": 66.494
	},
	{
		"id": 53311,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 40.5,
		"yearOfConstruction": 2022,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 825.0,
		"rentCalcSqm": 20.3704,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 45121,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 62.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 955.0,
		"rentCalcSqm": 15.28,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 88215,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Porokatu 37",
		"postalCode": "96400",
		"city": "Rovaniemi",
		"livingArea": 60.0,
		"yearOfConstruction": 1966,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 685.0,
		"rentCalcSqm": 11.4167,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7718,
		"y": 66.494
	},
	{
		"id": 53312,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 29.5,
		"yearOfConstruction": 2022,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 695.0,
		"rentCalcSqm": 23.5593,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 87457,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 1",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 57.0,
		"yearOfConstruction": 1978,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 550.0,
		"rentCalcSqm": 9.6491,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9892
	},
	{
		"id": 25528,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Lönnrotinkatu 41",
		"postalCode": "1",
		"city": "Helsinki",
		"livingArea": 48.5,
		"yearOfConstruction": 1940,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 1220.0,
		"rentCalcSqm": 25.1546,
		"owner": "Suomen Hypoteekkiyhdistys",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-11-30T00:00:00Z",
		"x": 24.9272,
		"y": 60.1627
	},
	{
		"id": 45122,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 59.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 935.0,
		"rentCalcSqm": 15.8475,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45123,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 52.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 910.0,
		"rentCalcSqm": 17.3333,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 88216,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Porokatu 37",
		"postalCode": "96400",
		"city": "Rovaniemi",
		"livingArea": 60.0,
		"yearOfConstruction": 1966,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 685.0,
		"rentCalcSqm": 11.4167,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7718,
		"y": 66.494
	},
	{
		"id": 53313,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 29.5,
		"yearOfConstruction": 2022,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 695.0,
		"rentCalcSqm": 23.5593,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 45124,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 57.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 930.0,
		"rentCalcSqm": 16.3158,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 53314,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 26.0,
		"yearOfConstruction": 2022,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 645.0,
		"rentCalcSqm": 24.8077,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 45125,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 54.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 925.0,
		"rentCalcSqm": 16.9725,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 87458,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 1",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 75.0,
		"yearOfConstruction": 1978,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 675.0,
		"rentCalcSqm": 9.0,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9892
	},
	{
		"id": 87459,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 1",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 32.0,
		"yearOfConstruction": 1978,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 450.0,
		"rentCalcSqm": 14.0625,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9892
	},
	{
		"id": 88217,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Porokatu 37",
		"postalCode": "96400",
		"city": "Rovaniemi",
		"livingArea": 22.0,
		"yearOfConstruction": 1966,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 419.0,
		"rentCalcSqm": 19.0455,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7718,
		"y": 66.494
	},
	{
		"id": 53315,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 26.0,
		"yearOfConstruction": 2022,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 645.0,
		"rentCalcSqm": 24.8077,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 87460,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 1",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 57.0,
		"yearOfConstruction": 1978,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 550.0,
		"rentCalcSqm": 9.6491,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9892
	},
	{
		"id": 45126,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 88.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 1440.0,
		"rentCalcSqm": 16.2712,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 88218,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Porokatu 37",
		"postalCode": "96400",
		"city": "Rovaniemi",
		"livingArea": 60.0,
		"yearOfConstruction": 1966,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 685.0,
		"rentCalcSqm": 11.4167,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7718,
		"y": 66.494
	},
	{
		"id": 45127,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 76.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 1195.0,
		"rentCalcSqm": 15.7237,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 88219,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Porokatu 37",
		"postalCode": "96400",
		"city": "Rovaniemi",
		"livingArea": 60.0,
		"yearOfConstruction": 1966,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 685.0,
		"rentCalcSqm": 11.4167,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7718,
		"y": 66.494
	},
	{
		"id": 87461,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 3",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 35.0,
		"yearOfConstruction": 1974,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 0,
		"rentCalc": 482.0,
		"rentCalcSqm": 13.7714,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9898
	},
	{
		"id": 88220,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Porokatu 37",
		"postalCode": "96400",
		"city": "Rovaniemi",
		"livingArea": 22.0,
		"yearOfConstruction": 1966,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 419.0,
		"rentCalcSqm": 19.0455,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7718,
		"y": 66.494
	},
	{
		"id": 45128,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 62.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 960.0,
		"rentCalcSqm": 15.36,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45129,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 59.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 935.0,
		"rentCalcSqm": 15.8475,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 88221,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Porokatu 37",
		"postalCode": "96400",
		"city": "Rovaniemi",
		"livingArea": 22.0,
		"yearOfConstruction": 1966,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 419.0,
		"rentCalcSqm": 19.0455,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7718,
		"y": 66.494
	},
	{
		"id": 45130,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 52.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 915.0,
		"rentCalcSqm": 17.4286,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 87462,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 3",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 90.0,
		"yearOfConstruction": 1974,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 789.0,
		"rentCalcSqm": 8.7667,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9898
	},
	{
		"id": 53316,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 25.5,
		"yearOfConstruction": 2022,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 645.0,
		"rentCalcSqm": 25.2941,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 53317,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 24.5,
		"yearOfConstruction": 2022,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 640.0,
		"rentCalcSqm": 26.1224,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 45131,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Albertinkatu 17",
		"postalCode": "00120",
		"city": "Helsinki",
		"livingArea": 50.5,
		"yearOfConstruction": 1908,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 1590.0,
		"rentCalcSqm": 31.4851,
		"owner": "Suomen Hypoteekkiyhdistyksen Eläkesäätiö s.r.",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9369,
		"y": 60.162
	},
	{
		"id": 87463,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 1",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 57.0,
		"yearOfConstruction": 1978,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 550.0,
		"rentCalcSqm": 9.6491,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9892
	},
	{
		"id": 88222,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Porokatu 37",
		"postalCode": "96400",
		"city": "Rovaniemi",
		"livingArea": 22.0,
		"yearOfConstruction": 1966,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 419.0,
		"rentCalcSqm": 19.0455,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7718,
		"y": 66.494
	},
	{
		"id": 87464,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 3",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 73.0,
		"yearOfConstruction": 1974,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 692.0,
		"rentCalcSqm": 9.4795,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9898
	},
	{
		"id": 87465,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 3",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 57.0,
		"yearOfConstruction": 1974,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 564.0,
		"rentCalcSqm": 9.8947,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9898
	},
	{
		"id": 88223,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Porokatu 37",
		"postalCode": "96400",
		"city": "Rovaniemi",
		"livingArea": 60.0,
		"yearOfConstruction": 1966,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 685.0,
		"rentCalcSqm": 11.4167,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7718,
		"y": 66.494
	},
	{
		"id": 87466,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 3",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 73.0,
		"yearOfConstruction": 1974,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 692.0,
		"rentCalcSqm": 9.4795,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9898
	},
	{
		"id": 87467,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 3",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 57.0,
		"yearOfConstruction": 1974,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 564.0,
		"rentCalcSqm": 9.8947,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9898
	},
	{
		"id": 87468,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 3",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 57.0,
		"yearOfConstruction": 1974,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 564.0,
		"rentCalcSqm": 9.8947,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9898
	},
	{
		"id": 45132,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 63.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 970.0,
		"rentCalcSqm": 15.2756,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 87470,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 3",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 57.0,
		"yearOfConstruction": 1974,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 564.0,
		"rentCalcSqm": 9.8947,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9898
	},
	{
		"id": 88224,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Porokatu 37",
		"postalCode": "96400",
		"city": "Rovaniemi",
		"livingArea": 43.0,
		"yearOfConstruction": 1966,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 575.0,
		"rentCalcSqm": 13.3721,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7718,
		"y": 66.494
	},
	{
		"id": 87469,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 3",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 57.0,
		"yearOfConstruction": 1974,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 564.0,
		"rentCalcSqm": 9.8947,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9898
	},
	{
		"id": 88225,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Porokatu 37",
		"postalCode": "96400",
		"city": "Rovaniemi",
		"livingArea": 22.0,
		"yearOfConstruction": 1966,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 419.0,
		"rentCalcSqm": 19.0455,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7718,
		"y": 66.494
	},
	{
		"id": 45133,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 52.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 905.0,
		"rentCalcSqm": 17.2381,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 88226,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Porokatu 37",
		"postalCode": "96400",
		"city": "Rovaniemi",
		"livingArea": 43.0,
		"yearOfConstruction": 1966,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 575.0,
		"rentCalcSqm": 13.3721,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.7718,
		"y": 66.494
	},
	{
		"id": 45134,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 59.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 930.0,
		"rentCalcSqm": 15.7627,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 53318,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 44.5,
		"yearOfConstruction": 2022,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 850.0,
		"rentCalcSqm": 19.1011,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 53319,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 31.0,
		"yearOfConstruction": 2022,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 725.0,
		"rentCalcSqm": 23.3871,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 45135,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 57.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 930.0,
		"rentCalcSqm": 16.3158,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 88273,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pietarsaarenkatu 10",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 33.0,
		"yearOfConstruction": 1973,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 410.0,
		"rentCalcSqm": 12.4242,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6621,
		"y": 63.0711
	},
	{
		"id": 87471,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 3",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 35.0,
		"yearOfConstruction": 1974,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 0,
		"rentCalc": 482.0,
		"rentCalcSqm": 13.7714,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9898
	},
	{
		"id": 45136,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 63.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 970.0,
		"rentCalcSqm": 15.2756,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 53320,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 50.0,
		"yearOfConstruction": 2022,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 1060.0,
		"rentCalcSqm": 21.2,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 45137,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 58.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 960.0,
		"rentCalcSqm": 16.4103,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45138,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 52.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 915.0,
		"rentCalcSqm": 17.4286,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 53321,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 65.5,
		"yearOfConstruction": 2022,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 1280.0,
		"rentCalcSqm": 19.542,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 45139,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 57.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 935.0,
		"rentCalcSqm": 16.4035,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 88274,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pietarsaarenkatu 10",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 62.5,
		"yearOfConstruction": 1973,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 625.0,
		"rentCalcSqm": 10.0,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6621,
		"y": 63.0711
	},
	{
		"id": 45140,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 74.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 1175.0,
		"rentCalcSqm": 15.7718,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 53322,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 45.0,
		"yearOfConstruction": 2022,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 7,
		"rentCalc": 855.0,
		"rentCalcSqm": 19.0,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 45141,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 48.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 860.0,
		"rentCalcSqm": 17.732,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45142,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 44.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 850.0,
		"rentCalcSqm": 19.3182,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 88275,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pietarsaarenkatu 10",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 57.5,
		"yearOfConstruction": 1973,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 595.0,
		"rentCalcSqm": 10.3478,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6621,
		"y": 63.0711
	},
	{
		"id": 45143,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 74.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 1185.0,
		"rentCalcSqm": 15.906,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45144,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 74.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 1185.0,
		"rentCalcSqm": 15.906,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 88276,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pietarsaarenkatu 10",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 30.0,
		"yearOfConstruction": 1973,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 390.0,
		"rentCalcSqm": 13.0,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6621,
		"y": 63.0711
	},
	{
		"id": 87472,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 3",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 31.5,
		"yearOfConstruction": 1974,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 0,
		"rentCalc": 461.0,
		"rentCalcSqm": 14.6349,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9898
	},
	{
		"id": 88277,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pietarsaarenkatu 10",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 62.5,
		"yearOfConstruction": 1973,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 625.0,
		"rentCalcSqm": 10.0,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6621,
		"y": 63.0711
	},
	{
		"id": 88278,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pietarsaarenkatu 10",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 30.0,
		"yearOfConstruction": 1973,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 390.0,
		"rentCalcSqm": 13.0,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6621,
		"y": 63.0711
	},
	{
		"id": 45145,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 59.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 950.0,
		"rentCalcSqm": 16.1017,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 53323,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 31.0,
		"yearOfConstruction": 2022,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 730.0,
		"rentCalcSqm": 23.5484,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 88279,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pietarsaarenkatu 10",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 77.5,
		"yearOfConstruction": 1973,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 705.0,
		"rentCalcSqm": 9.0968,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6621,
		"y": 63.0711
	},
	{
		"id": 88280,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pietarsaarenkatu 10",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 77.5,
		"yearOfConstruction": 1973,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 705.0,
		"rentCalcSqm": 9.0968,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6621,
		"y": 63.0711
	},
	{
		"id": 87473,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 3",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 31.5,
		"yearOfConstruction": 1974,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 0,
		"rentCalc": 461.0,
		"rentCalcSqm": 14.6349,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9898
	},
	{
		"id": 45146,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 52.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 920.0,
		"rentCalcSqm": 17.5238,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 87474,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 3",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 35.0,
		"yearOfConstruction": 1974,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 0,
		"rentCalc": 482.0,
		"rentCalcSqm": 13.7714,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9898
	},
	{
		"id": 88281,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pietarsaarenkatu 10",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 30.0,
		"yearOfConstruction": 1973,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 390.0,
		"rentCalcSqm": 13.0,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6621,
		"y": 63.0711
	},
	{
		"id": 45147,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 59.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 945.0,
		"rentCalcSqm": 16.0169,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45148,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 58.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 965.0,
		"rentCalcSqm": 16.4957,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 87475,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 3",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 46.5,
		"yearOfConstruction": 1974,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 543.0,
		"rentCalcSqm": 11.6774,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9898
	},
	{
		"id": 53324,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 50.0,
		"yearOfConstruction": 2022,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 1065.0,
		"rentCalcSqm": 21.3,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 45149,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 91.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 1460.0,
		"rentCalcSqm": 16.044,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 88282,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pietarsaarenkatu 10",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 77.5,
		"yearOfConstruction": 1973,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 705.0,
		"rentCalcSqm": 9.0968,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6621,
		"y": 63.0711
	},
	{
		"id": 45150,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 57.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 935.0,
		"rentCalcSqm": 16.4035,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 87476,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Salpatie 3",
		"postalCode": "15880",
		"city": "Hollola",
		"livingArea": 46.5,
		"yearOfConstruction": 1974,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 543.0,
		"rentCalcSqm": 11.6774,
		"owner": "Olo Asunnot 8 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.4911,
		"y": 60.9898
	},
	{
		"id": 88283,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pietarsaarenkatu 10",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 77.5,
		"yearOfConstruction": 1973,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 705.0,
		"rentCalcSqm": 9.0968,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6621,
		"y": 63.0711
	},
	{
		"id": 53325,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Koelaitoksenkatu 22",
		"postalCode": "33180",
		"city": "Tampere",
		"livingArea": 65.5,
		"yearOfConstruction": 2022,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 1285.0,
		"rentCalcSqm": 19.6183,
		"owner": "OP Vuokrakoti Ky",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 23.7658,
		"y": 61.5067
	},
	{
		"id": 53326,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kuhasalontie 14",
		"postalCode": "80220",
		"city": "Joensuu",
		"livingArea": 31.75,
		"yearOfConstruction": 1974,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 670.0,
		"rentCalcSqm": 21.1024,
		"owner": "Olo Asunnot 14 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-03-31T00:00:00Z",
		"x": 29.7639,
		"y": 62.5839
	},
	{
		"id": 45151,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 62.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 5,
		"rentCalc": 960.0,
		"rentCalcSqm": 15.36,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45152,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 62.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 950.0,
		"rentCalcSqm": 15.2,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 45153,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 57.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 940.0,
		"rentCalcSqm": 16.4912,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 88284,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pietarsaarenkatu 10",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 75.5,
		"yearOfConstruction": 1973,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 685.0,
		"rentCalcSqm": 9.0728,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6621,
		"y": 63.0711
	},
	{
		"id": 87477,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 60.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 545.0,
		"rentCalcSqm": 9.0083,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 88285,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pietarsaarenkatu 10",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 93.5,
		"yearOfConstruction": 1973,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 795.0,
		"rentCalcSqm": 8.5027,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6621,
		"y": 63.0711
	},
	{
		"id": 88286,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Louhikkotie 10",
		"postalCode": "96500",
		"city": "Rovaniemi",
		"livingArea": 86.5,
		"yearOfConstruction": 1967,
		"numberOfRooms": 4,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 920.0,
		"rentCalcSqm": 10.6358,
		"owner": "Olo Asunnot 13 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 25.6838,
		"y": 66.5095
	},
	{
		"id": 45154,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 62.5,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 4,
		"rentCalc": 960.0,
		"rentCalcSqm": 15.36,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 32324,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 52.5,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 740.0,
		"rentCalcSqm": 14.0952,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 87478,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 79.5,
		"yearOfConstruction": 1979,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 599.0,
		"rentCalcSqm": 7.5346,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	},
	{
		"id": 32325,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Kulmakatu 12",
		"postalCode": "15140",
		"city": "Lahti",
		"livingArea": 53.0,
		"yearOfConstruction": 1997,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 769.0,
		"rentCalcSqm": 14.5094,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2021-12-31T00:00:00Z",
		"x": 25.6636,
		"y": 60.9863
	},
	{
		"id": 88287,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pietarsaarenkatu 8",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 30.0,
		"yearOfConstruction": 1973,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 3,
		"rentCalc": 390.0,
		"rentCalcSqm": 13.0,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6611,
		"y": 63.0713
	},
	{
		"id": 45155,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Käräjäkuja 1",
		"postalCode": "01510",
		"city": "Vantaa",
		"livingArea": 59.0,
		"yearOfConstruction": 1999,
		"numberOfRooms": 2,
		"roomsDescription": null,
		"floorNumber": 6,
		"rentCalc": 950.0,
		"rentCalcSqm": 16.1017,
		"owner": "Keskinäinen työeläkevakuutusyhtiö Varma",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-02-28T00:00:00Z",
		"x": 24.9474,
		"y": 60.2869
	},
	{
		"id": 88288,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Pietarsaarenkatu 8",
		"postalCode": "65350",
		"city": "Vaasa",
		"livingArea": 77.5,
		"yearOfConstruction": 1973,
		"numberOfRooms": 3,
		"roomsDescription": null,
		"floorNumber": 1,
		"rentCalc": 705.0,
		"rentCalcSqm": 9.0968,
		"owner": "Olo Asunnot 15 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 21.6611,
		"y": 63.0713
	},
	{
		"id": 87479,
		"accommodationType": "Ei tietoa",
		"apartmentType": "apartment",
		"address": "Suksisepäntie 8",
		"postalCode": "50160",
		"city": "Mikkeli",
		"livingArea": 33.0,
		"yearOfConstruction": 1979,
		"numberOfRooms": 1,
		"roomsDescription": null,
		"floorNumber": 2,
		"rentCalc": 420.0,
		"rentCalcSqm": 12.7273,
		"owner": "Olo Asunnot 9 Oy",
		"source": "Newsec PAM",
		"condition": null,
		"hasSauna": true,
		"observationTime": "2022-07-31T00:00:00Z",
		"x": 27.2613,
		"y": 61.6659
	}
]


// WEBPACK FOOTER //
// ./src/hardCodedData/renttransactions.ts